webpackJsonp([5],{

/***/ "/jCf":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIyNiIgdmlld0JveD0iMCAwIDMyIDI2Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzMyIiBkYXRhLW5hbWU9IuOCsOODq+ODvOODlyAzMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMzNCAtMjQpIj4KICAgIDxsaW5lIGlkPSLnt5pfMSIgZGF0YS1uYW1lPSLnt5ogMSIgeDI9IjMwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMzUgMjUpIiBmaWxsPSJub25lIiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8bGluZSBpZD0i57eaXzEtMiIgZGF0YS1uYW1lPSLnt5ogMSIgeDI9IjMwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMzUgMzcpIiBmaWxsPSJub25lIiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8bGluZSBpZD0i57eaXzEtMyIgZGF0YS1uYW1lPSLnt5ogMSIgeDI9IjMwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMzUgNDkpIiBmaWxsPSJub25lIiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "1n9X":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDQyIDE2Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzIwMzMiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDIwMzMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xODQ2MSAtNjI2MSkiPgogICAgPGcgaWQ9IuOCsOODq+ODvOODl18yMDE4IiBkYXRhLW5hbWU9IuOCsOODq+ODvOODlyAyMDE4Ij4KICAgICAgPGxpbmUgaWQ9Iue3ml8xOTUiIGRhdGEtbmFtZT0i57eaIDE5NSIgeDI9IjEyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODQ3Ni41IDYyNjkuNSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZhM2QzZCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICAgIDxnIGlkPSLmpZXlhoblvaJfMTA3IiBkYXRhLW5hbWU9IualleWGhuW9oiAxMDciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NDg3IDYyNjEpIiBmaWxsPSIjZmZmIiBzdHJva2U9IiNhYWEiIHN0cm9rZS13aWR0aD0iMSI+CiAgICAgICAgPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIHN0cm9rZT0ibm9uZSIvPgogICAgICAgIDxjaXJjbGUgY3g9IjgiIGN5PSI4IiByPSI3LjUiIGZpbGw9Im5vbmUiLz4KICAgICAgPC9nPgogICAgICA8Y2lyY2xlIGlkPSLmpZXlhoblvaJfMTA5IiBkYXRhLW5hbWU9IualleWGhuW9oiAxMDkiIGN4PSI4IiBjeT0iOCIgcj0iOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTg0NjEgNjI2MSkiIGZpbGw9IiNmYTNkM2QiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "2PDt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/toastMethods.vue




/* harmony default export */ var toastMethods = ({
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['addToastAction']), {
    addToast: function addToast(type, content, title) {
      var data = {
        type: type,
        title: title,
        content: content
      };
      this.addToastAction(data);
    }
  })
});
// CONCATENATED MODULE: ./src/mixins/toastMethods.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  toastMethods,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_toastMethods = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4G+f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/googleMap.vue


//
//
//
//
//
//

/* eslint-disable */
var _google = null;
var _MarkerClusterer = null;
setTimeout(function () {
  _google = google;
  _MarkerClusterer = MarkerClusterer;
}, 1000);
/* eslint-enable */

/* harmony default export */ var googleMap = ({
  props: {
    countryName: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    position: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    needClusterer: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    mapOption: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    mapEvents: {
      type: Array,
      default: function _default() {
        return ['center_changed'];
      }
    },
    markerOptions: {
      type: Array,
      default: function _default() {
        return null;
      }
    },
    markerEvents: {
      type: Array,
      default: function _default() {
        return ['click'];
      }
    }
  },
  data: function data() {
    return {
      country: null,
      mapObj: {
        geocoder: null,
        map: null,
        markers: null,
        clusterer: null
      }
    };
  },
  mounted: function mounted() {
    this.getCountry();
  },

  watch: {
    'mapOption': function mapOption(nv, ov) {
      if (stringify_default()(nv) !== stringify_default()(ov)) {
        this.init();
      }
    },
    'markerOptions': function markerOptions(nv, ov) {
      if (stringify_default()(nv) !== stringify_default()(ov)) {
        this.init(true);
      }
    },
    'mapEvents': function mapEvents(nv, ov) {
      if (stringify_default()(nv) !== stringify_default()(ov)) {
        this.setEventListener();
      }
    },
    'markerEvents': function markerEvents(nv, ov) {
      if (stringify_default()(nv) !== stringify_default()(ov)) {
        this.setEventListener();
      }
    }
  },
  methods: {
    getCountry: function getCountry() {
      var _this = this;

      this.mapObj.geocoder = new _google.maps.Geocoder();
      this.mapObj.geocoder.geocode({ address: this.countryName }, function (results, status) {
        if (status === 'OK') {
          if (results[0]) {
            _this.country = results[0];
          }
        }
        _this.init();
      });
    },
    init: function init() {
      var onlyMarker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.initMap(onlyMarker)) {
        this.setEventListener(onlyMarker);
      }
    },
    initMap: function initMap(onlyMarker) {
      var _this2 = this;

      try {
        if (!onlyMarker) {
          var center = this.position ? { lat: this.position.lat, lng: this.position.lng } : this.country ? { lat: this.country.geometry.location.lat(), lng: this.country.geometry.location.lng() } : null;
          this.mapObj.map = new _google.maps.Map(this.$refs['map'], extends_default()({
            zoom: 8,
            center: center || (this.markerOptions[0] ? this.markerOptions[0].position : { lat: 0, lng: 0 })
          }, this.mapOption || {}));
        } else {
          this.mapObj.markers.forEach(function (marker) {
            return marker.setMap(null);
          });
        }
        this.mapObj.markers = this.markerOptions.map(function (markerOption) {
          return new _google.maps.Marker(extends_default()({
            map: _this2.mapObj.map
          }, markerOption || {}));
        });
        if (this.needClusterer) {
          this.mapObj.clusterer = new _MarkerClusterer(this.mapObj.map, this.mapObj.markers, {
            imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
          });
        }
        return true;
      } catch (error) {
        return false;
      }
    },
    setEventListener: function setEventListener(onlyMarker) {
      var _this3 = this;

      if (!onlyMarker) {
        this.mapEvents.forEach(function (event) {
          _this3.mapObj.map.addListener(event, function () {
            _this3.$emit('mapEvent', event, _this3.mapObj.map);
          });
        });
      }
      this.markerEvents.forEach(function (event) {
        _this3.mapObj.markers.forEach(function (marker) {
          marker.addListener(event, function () {
            _this3.$emit('markerEvent', event, marker, _this3.mapObj.map);
          });
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b887288","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/googleMap.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"google-map"}},[_c('div',{ref:"map"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_googleMap = (esExports);
// CONCATENATED MODULE: ./src/components/tool/googleMap.vue
function injectStyle (ssrContext) {
  __webpack_require__("IBQk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  googleMap,
  tool_googleMap,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_googleMap = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "598Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ls__ = __webpack_require__("yXtV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_ls__);



var options = {
  namespace: 'ihn_expert_'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_ls___default.a, options);

/***/ }),

/***/ "9zQ9":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "BA3z":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMC41IiBoZWlnaHQ9IjIwLjUiIHZpZXdCb3g9IjAgMCAyMC41IDIwLjUiPgogIDxnIGlkPSLjgrDjg6vjg7zjg5dfODI3MCIgZGF0YS1uYW1lPSLjgrDjg6vjg7zjg5cgODI3MCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTYxMS4xMjUgLTQ2LjIwNykiPgogICAgPGcgaWQ9IuOCsOODq+ODvOODl18xIiBkYXRhLW5hbWU9IuOCsOODq+ODvOODlyAxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2MTcuMzc1IDQ5LjQ1NykiPgogICAgICA8cGF0aCBpZD0i44OR44K5XzEiIGRhdGEtbmFtZT0i44OR44K5IDEiIGQ9Ik02NDYuNzU1LDU3Ljg2OGwtNC4xNDUsMTNhNi4wMzYsNi4wMzYsMCwwLDEsNC4zMzgtMi40YzIuNTE3LDAsNC42NjIsMi40LDQuNjYyLDIuNFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02NDIuNjEgLTU3Ljg2OCkiIGZpbGw9IiNmZmJhMDAiLz4KICAgIDwvZz4KICAgIDxwYXRoIGlkPSLjg5HjgrlfMiIgZGF0YS1uYW1lPSLjg5HjgrkgMiIgZD0iTTYzMi4zNzUsNTYuNDU3YTEwLDEwLDAsMSwxLTEwLTEwQTEwLDEwLDAsMCwxLDYzMi4zNzUsNTYuNDU3Wm0tMTAtOS40NWE5LjQ1LDkuNDUsMCwxLDAsOS40NSw5LjQ1QTkuNDUsOS40NSwwLDAsMCw2MjIuMzc1LDQ3LjAwN1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xKSIgZmlsbD0iI2ZmYmEwMCIgc3Ryb2tlPSIjZmZiYTAwIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMC41Ii8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "BBXg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIyNS4wMjEiIHZpZXdCb3g9IjAgMCAzMiAyNS4wMjEiPgogIDxnIGlkPSLjgrDjg6vjg7zjg5dfODMxOCIgZGF0YS1uYW1lPSLjgrDjg6vjg7zjg5cgODMxOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMzNCAtMTgpIj4KICAgIDxnIGlkPSLjgrPjg7Pjg53jg7zjg43jg7Pjg4hfMV8xIiBkYXRhLW5hbWU9IuOCs+ODs+ODneODvOODjeODs+ODiCAxIOKAkyAxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMzUgMTkpIj4KICAgICAgPGxpbmUgaWQ9Iue3ml8xIiBkYXRhLW5hbWU9Iue3miAxIiB4Mj0iMzAiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzcwNzA3MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIG9wYWNpdHk9IjAiLz4KICAgICAgPGxpbmUgaWQ9Iue3ml8xLTIiIGRhdGEtbmFtZT0i57eaIDEiIHgyPSIzMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNC4zOTMgMS4zOTMpIHJvdGF0ZSg0NSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzcwNzA3MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiLz4KICAgICAgPGxpbmUgaWQ9Iue3ml8xLTMiIGRhdGEtbmFtZT0i57eaIDEiIHgyPSIzMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNC4zOTQgMjIuNjA3KSByb3RhdGUoLTQ1KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNzA3MDcwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "DBs5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");



var config = {
  locale: 'tc',
  events: 'input',
  dictionary: {
    en: {
      messages: {
        required: function required(field) {
          return field + ' should not be empty.';
        },
        min: function min(field, args) {
          return field + ' should be more than ' + args + ' alphamunerics.';
        },
        max: function max(field, args) {
          return field + ' should be less than ' + args + ' alphamunerics.';
        },
        digits: function digits(field, args) {
          return field + ' should be ' + args + ' digit';
        },
        min_value: function min_value(field, args) {
          return field + ' should be more than ' + args;
        },
        max_value: function max_value(field, args) {
          return field + ' should be less than ' + args;
        },
        integer: function integer(field) {
          return field + ' should be integer';
        },
        mimes: function mimes(field, args) {
          return field + ' should be mime ' + args;
        },
        ext: function ext(field, args) {
          return field + ' should be extension ' + args;
        },
        dimensions: function dimensions(field, args) {
          return field + ' should be ' + args;
        },
        regex: function regex(field) {
          return 'The ' + field + ' is incorrect.';
        },
        url: function url(field) {
          return 'The ' + field + ' is incorrect.';
        },
        email: function email() {
          return 'Please enter right email format.';
        },
        confirmed: function confirmed() {
          return 'Password confirmation is incorrect.';
        },
        youtubeLink: function youtubeLink(field) {
          return field + ' is not youtube link';
        }
      },
      attributes: {}
    },
    tc: {
      messages: {
        required: function required(field) {
          return field + ' 欄位必填';
        },
        min: function min(field, args) {
          return field + ' 最少 ' + args + ' 個字';
        },
        max: function max(field, args) {
          return field + ' 不得超過 ' + args + ' 個字';
        },
        digits: function digits(field, args) {
          return field + ' 請輸入 ' + args + ' 位數字';
        },
        min_value: function min_value(field, args) {
          return field + ' 不得低於 ' + args;
        },
        max_value: function max_value(field, args) {
          return field + ' 不得超過 ' + args;
        },
        integer: function integer(field) {
          return field + ' 必須為整數';
        },
        mimes: function mimes(field, args) {
          return field + ' 必須符合MIME類型 ' + args;
        },
        ext: function ext(field, args) {
          return field + ' 必須符合檔案類型 ' + args;
        },
        dimensions: function dimensions(field, args) {
          return field + ' 寬與高須分別為 ' + args;
        },
        regex: function regex(field) {
          return '無效的 ' + field;
        },
        url: function url(field) {
          return '無效的 ' + field;
        },
        email: function email(field) {
          return field + ' 請輸入正確Email格式';
        },
        confirmed: function confirmed() {
          return '密碼不相符';
        },
        youtubeLink: function youtubeLink(field) {
          return field + ' 不是youtube內嵌影片連結格式';
        }
      },
      attributes: {}
    }
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* default */], config);

/***/ }),

/***/ "E4co":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/responsitive.vue

/* harmony default export */ var responsitive = ({
  data: function data() {
    return {
      rs_timer: null,
      headerHeight: 0,
      footerHeight: 0,
      windowWidth: 0,
      windowHeight: 0,
      scrollbarSize: 0
    };
  },

  computed: {
    isMobile: function isMobile() {
      return this.windowWidth <= 1099.9;
    }
  },
  created: function created() {
    var _this = this;

    var handler = function handler() {
      _this.rs_timer && clearTimeout(_this.rs_timer);
      if (window.innerHeight > window.screen.height) {
        _this.rs_timer = setTimeout(function () {
          _this.rs_timer = null;
          window.dispatchEvent(new Event('resize'));
        }, 100);
      } else {
        _this.windowWidth = window.innerWidth;
        _this.windowHeight = window.innerHeight;
        _this.headerHeight = _this.isMobile ? 60 : 0;
      }
    };
    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
    window.dispatchEvent(new Event('resize'));
  },
  mounted: function mounted() {
    var scrollBox = document.getElementById('scroll-box');
    this.scrollbarSize = scrollBox.offsetWidth - scrollBox.clientWidth;
  }
});
// CONCATENATED MODULE: ./src/mixins/responsitive.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  responsitive,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_responsitive = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EGMj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fqd/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),

/***/ "HALv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/borCor.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var borCor = ({
  props: {
    type: {
      type: String,
      default: function _default() {
        return 'bottom';
      }
    },
    reverse: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    arrow: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    tooltip: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    display: {
      type: Boolean,
      default: function _default() {
        return null;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // style
    width: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    background: {
      type: String,
      default: function _default() {
        return 'white';
      }
    },
    border: {
      type: String,
      default: function _default() {
        return '#aaaaaa';
      }
    },
    radius: {
      type: String,
      default: function _default() {
        return '3px';
      }
    },
    shadow: {
      type: String,
      default: function _default() {
        return '1px 2px 3px rgba(0, 0, 0, 0.16)';
      }
    },
    translate: {
      type: String,
      default: function _default() {
        return '0px 0px';
      }
    },
    deviation: {
      type: String,
      default: function _default() {
        return '15px 15px';
      }
    },
    arrowSize: {
      type: String,
      default: function _default() {
        return '10px 10px';
      }
    },
    cursorSize: {
      type: String,
      default: function _default() {
        return '40px 40px';
      }
    },
    blockStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    menuBlockStyle: function menuBlockStyle() {
      var width = this.width || 'auto';
      var style = {
        width: width,
        'white-space': width !== 'auto' ? 'pre-line' : 'nowrap',
        '--bg-color': this.background,
        '--bd-color': this.border,
        '--br-value': this.radius
      };
      return extends_default()({}, style, this.blockStyle);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-644715c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/borCor.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bor-cor",class:{ 'no-arrow': !_vm.arrow, 'is-tooltip': _vm.tooltip }},[_c('div',{staticClass:"trigger",class:{ display: _vm.display !== false, 'always-display': _vm.display }},[_vm._t("trigger")],2),_vm._v(" "),(!_vm.disabled)?_c('div',{staticClass:"menu-container",class:[_vm.type, { reverse: _vm.reverse }],style:({
      'transform': 'translate(' + _vm.translate.split(' ').join(', ') + ')',
      '--sd-style': _vm.shadow,
      '--dvt-v': _vm.deviation.split(' ')[0],
      '--dvt-h': _vm.deviation.split(' ')[1],
      '--arw-w': _vm.arrowSize.split(' ')[0],
      '--arw-h': _vm.arrowSize.split(' ')[1],
      '--cbc-w': _vm.cursorSize.split(' ')[0],
      '--cbc-h': _vm.cursorSize.split(' ')[1],
      '--tt-v': (_vm.tooltip || {}).v || '5px',
      '--tt-h': (_vm.tooltip || {}).h || '5px'
    }),on:{"mouseleave":function (e) { return _vm.$emit('leave'); }}},[_c('div',{staticClass:"menu-block",style:(_vm.menuBlockStyle)},[_vm._t("content")],2),_vm._v(" "),(!_vm.tooltip)?_c('span',{staticClass:"cursor-bor-cor",on:{"click":function (e) { return _vm.$emit('click'); }}}):_vm._e(),_vm._v(" "),(_vm.arrow && !_vm.tooltip)?[_c('span',{staticClass:"menu-bor-cor shadow-top",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-left",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-right",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor",style:({ '--bg-color': _vm.background })})]:_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_borCor = (esExports);
// CONCATENATED MODULE: ./src/components/tool/borCor.vue
function injectStyle (ssrContext) {
  __webpack_require__("EGMj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  borCor,
  tool_borCor,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_borCor = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IBQk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IMLV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),

/***/ "LFf6":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDEyIDE2Ij4KICA8cGF0aCBpZD0iZG5hLWxpZ2h0IiBkPSJNNDMuNSwwYS41LjUsMCwwLDEsLjUuNWMwLDMuNzU2LTIuOTQ0LDUuODk0LTUuNjE2LDcuODQxbC0uMDg4LjA2NkEyNi45MTMsMjYuOTEzLDAsMCwwLDM1LjA4MSwxMWg1Ljg0NGExOS45NDcsMTkuOTQ3LDAsMCwwLTIuMTA5LTEuNzgxYy4xLS4wNzIuMi0uMTQ0LjMtLjIxNi4xODQtLjEzMS4zNjYtLjI2Mi41NS0uNEM0MS45MTksMTAuMzI1LDQ0LDEyLjM0MSw0NCwxNS41YS41LjUsMCwwLDEtMSwwYzAtLjE3Mi0uMDA2LS4zMzctLjAyMi0uNUgzMy4wMjJjLS4wMTIuMTYzLS4wMjIuMzI4LS4wMjIuNWEuNS41LDAsMSwxLTEsMGMwLTMuNTM4LDIuNjEyLTUuNjQxLDUuMTUtNy41QzM0LjYxMiw2LjE0MSwzMiw0LjAzNywzMiwuNWEuNS41LDAsMSwxLDEsMGMwLC4xNzIuMDA2LjMzNy4wMjIuNWg5Ljk1NkM0Mi45OTEuODM3LDQzLC42NzIsNDMsLjVBLjUuNSwwLDAsMSw0My41LDBabS0uNywySDMzLjJhNiw2LDAsMCwwLDEuMDA2LDJINDEuOEE2LDYsMCwwLDAsNDIuOCwyWk00MC45MjIsNUgzNS4wNzhBMjQuNTgzLDI0LjU4MywwLDAsMCwzOCw3LjM4MSwyNC41ODMsMjQuNTgzLDAsMCwwLDQwLjkyMiw1Wk0zMy4yLDE0aDkuNmE2LjAxNiw2LjAxNiwwLDAsMC0xLjAwNi0yYy0uMDE2LDAtLjAyOCwwLS4wNDQsMGgtNy41YS4yMDYuMjA2LDAsMCwxLS4wNDQsMEE1Ljk1OCw1Ljk1OCwwLDAsMCwzMy4yLDE0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMyKSIgZmlsbD0iIzAwMzY3OSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-meta/lib/vue-meta.js
var vue_meta = __webpack_require__("p3jY");
var vue_meta_default = /*#__PURE__*/__webpack_require__.n(vue_meta);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/api/index.js
var api = __webpack_require__("gyMJ");

// CONCATENATED MODULE: ./src/constants/global/data.js
var data_externalLinkDatas = function externalLinkDatas() {
  var lang = {
    'ja': 'ja'
  }[localStorage.getItem('locale') || window.navigator.language || navigator.userLanguage] || 'en';
  return {
    'compassbioinfo': {
      'ja': 'https://compassbioinfo.jp/',
      'en': 'https://compassbioinfo.com/'
    }[lang],
    'inherinext': {
      'ja': 'https://edge.inherinext.jp/',
      'en': 'https://edge.inherinext.com/'
    }[lang]
  };
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sidebar/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var main = ({
  props: {
    type: {
      type: String,
      default: function _default() {
        return 'default';
      }
    },
    active: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  },
  computed: {
    // static
    menuOptions: function menuOptions() {
      return {
        'top': [{
          icon: __webpack_require__("PNRC"),
          title: this.$t('LAYOUT.sidebar.menuOption.title.___phenotype'),
          to: { name: 'phenotypeDisease' },
          active: ['phenotypeDisease'].includes(this.$route.name)
        }, {
          icon: __webpack_require__("LFf6"),
          title: this.$t('LAYOUT.sidebar.menuOption.title.___genePanel'),
          to: { name: 'genePanel' },
          active: ['genePanel'].includes(this.$route.name)
        }],
        'bottom': [
          // {
          //   icon: require('../../assets/menuIcons/introduction-menu-icon.svg'),
          //   title: this.$t('LAYOUT.sidebar.menuOption.title.___introduction'),
          //   to: { name: 'main' },
          //   active: ['main'].includes(this.$route.name)
          // }
        ]
      };
    },

    // global
    externalLinkDatas: function externalLinkDatas() {
      return data_externalLinkDatas;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-042d4e8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-main-page col-block",class:[{ active: _vm.active }, _vm.type]},[_c('div',{staticClass:"sidebar-main-container width-transition col-block width-full",style:({ flex: 1 })},[(['default'].includes(_vm.type))?_c('a',{staticClass:"sidebar-main-logo-container center-block",attrs:{"href":_vm.externalLinkDatas()['compassbioinfo'],"target":"_blank"}},[_c('div',{staticClass:"sidebar-main-logo-block row-block"},[_c('div',{staticClass:"sidebar-main-logo-icon center-block"},[_c('img',{style:({ 'max-width': '20px' }),attrs:{"src":__webpack_require__("BA3z"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"sidebar-main-logo-title hidden-text width-transition"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('LAYOUT.sidebar.___logoTitle').split(' ').join('<br>'))}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sidebar-main-menu-list-container col-block width-full"},_vm._l((_vm.menuOptions['top']),function(menuOption,moindex){return _c('router-link',{key:moindex,staticClass:"sidebar-main-menu-field col-block width-full",class:{ active: menuOption.active },attrs:{"to":menuOption.to}},[_c('div',{staticClass:"sidebar-main-menu-container center-block",style:({ flex: 1 })},[_c('div',{staticClass:"sidebar-main-menu-block row-block"},[_c('div',{staticClass:"sidebar-main-menu-icon center-block icon-block",style:({ '--size': '20px' })},[_c('img',{attrs:{"src":menuOption.icon,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"sidebar-main-menu-title hidden-text width-transition"},[_vm._v(_vm._s(menuOption.title))])])])])}),1),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"sidebar-main-menu-list-container col-block width-full"},_vm._l((_vm.menuOptions['bottom']),function(menuOption,moindex){return _c('router-link',{key:moindex,staticClass:"sidebar-main-menu-field col-block width-full",class:{ active: menuOption.active },attrs:{"to":menuOption.to}},[_c('div',{staticClass:"sidebar-main-menu-container center-block",style:({ flex: 1 })},[_c('div',{staticClass:"sidebar-main-menu-block row-block"},[_c('div',{staticClass:"sidebar-main-menu-icon center-block icon-block",style:({ '--size': '20px' })},[_c('img',{attrs:{"src":menuOption.icon,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"sidebar-main-menu-title hidden-text width-transition"},[_vm._v(_vm._s(menuOption.title))])])])])}),1),_vm._v(" "),_c('div',{staticClass:"sidebar-main-button-container center-block"},[_c('a',{attrs:{"href":_vm.externalLinkDatas()['inherinext'],"target":"_blank"}},[_c('button',{staticClass:"sidebar-main-button main-button small-button circle-button row-block width-transition",class:{ 'flex-reverse': ['ja'].includes(_vm.$i18n.locale) }},[_c('div',{staticClass:"sidebar-main-button-text"},[_vm._v(_vm._s(_vm.$t('LAYOUT.sidebar.___tryButton01')))]),_vm._v(" "),_c('div',{staticClass:"sidebar-main-button-text hidden-text width-transition"},[_vm._v(_vm._s(_vm.$t('LAYOUT.sidebar.___tryButton02')))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var sidebar_main = (esExports);
// CONCATENATED MODULE: ./src/components/sidebar/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  main,
  sidebar_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_sidebar_main = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/sidebar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var sidebar = ({
  components: {
    sidebarMain: components_sidebar_main
  },
  props: {
    minHeight: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      active: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52f6adb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/sidebar.vue
var sidebar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar row-block height-full",class:{ active: _vm.active },style:({ height: _vm.minHeight + 'px' }),on:{"mouseenter":function (e) { return _vm.active = true; },"mouseleave":function (e) { return _vm.active = false; }}},[_c('sidebarMain',{attrs:{"active":_vm.active}})],1)}
var sidebar_staticRenderFns = []
var sidebar_esExports = { render: sidebar_render, staticRenderFns: sidebar_staticRenderFns }
/* harmony default export */ var layout_sidebar = (sidebar_esExports);
// CONCATENATED MODULE: ./src/components/layout/sidebar.vue
var sidebar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sidebar___vue_template_functional__ = false
/* styles */
var sidebar___vue_styles__ = null
/* scopeId */
var sidebar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sidebar___vue_module_identifier__ = null
var sidebar_Component = sidebar_normalizeComponent(
  sidebar,
  layout_sidebar,
  sidebar___vue_template_functional__,
  sidebar___vue_styles__,
  sidebar___vue_scopeId__,
  sidebar___vue_module_identifier__
)

/* harmony default export */ var components_layout_sidebar = (sidebar_Component.exports);

// EXTERNAL MODULE: ./src/mixins/toastMethods.vue + 1 modules
var toastMethods = __webpack_require__("2PDt");

// EXTERNAL MODULE: ./src/mixins/responsitive.vue + 1 modules
var responsitive = __webpack_require__("E4co");

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// EXTERNAL MODULE: ./src/constants/lang/i18n.js + 2 modules
var i18n = __webpack_require__("tZBu");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/locale.vue




/* harmony default export */ var mixins_locale = ({
  data: function data() {
    return {
      locale: i18n["a" /* default */].locale
    };
  },

  computed: {
    // static
    languageOptions: function languageOptions() {
      return [{
        title: 'English',
        value: 'en'
      }, {
        title: '日本語',
        value: 'ja'
      }];
    }
  },
  methods: {
    setLang: function setLang(locale) {
      i18n["a" /* default */].locale = locale;
      vee_validate_esm["a" /* Validator */].localize(locale);
      localStorage.setItem('locale', locale);
      this.locale = locale;
    }
  }
});
// CONCATENATED MODULE: ./src/mixins/locale.vue
var locale_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var locale___vue_template_functional__ = false
/* styles */
var locale___vue_styles__ = null
/* scopeId */
var locale___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var locale___vue_module_identifier__ = null
var locale_Component = locale_normalizeComponent(
  mixins_locale,
  __vue_template__,
  locale___vue_template_functional__,
  locale___vue_styles__,
  locale___vue_scopeId__,
  locale___vue_module_identifier__
)

/* harmony default export */ var src_mixins_locale = (locale_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/loginData.vue




/* harmony default export */ var loginData = ({
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setUserAction', 'setLoginAction', 'setUserInfoAction']), {
    setUserData: function setUserData(response, token) {
      var user = response ? response.data.user || response.data.data : null;
      token = token || (response ? response.data.auth : null);
      this.setUserAction(user);
      this.setLoginAction(!!response);
      this.setUserInfo(token);
      return user;
    },
    setUserInfo: function setUserInfo(token) {
      if (token) {
        // let expiry = new Date(token.expired_at) - new Date()
        var info = {
          access_token: token.access_token
        };
        this.setUserInfoAction(info);
        this.$ls.set('userInfo', info);
      } else {
        this.setUserInfoAction(null);
        this.$ls.remove('userInfo');
      }
    }
  })
});
// CONCATENATED MODULE: ./src/mixins/loginData.vue
var loginData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var loginData___vue_template__ = null
/* template functional */
var loginData___vue_template_functional__ = false
/* styles */
var loginData___vue_styles__ = null
/* scopeId */
var loginData___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loginData___vue_module_identifier__ = null
var loginData_Component = loginData_normalizeComponent(
  loginData,
  loginData___vue_template__,
  loginData___vue_template_functional__,
  loginData___vue_styles__,
  loginData___vue_scopeId__,
  loginData___vue_module_identifier__
)

/* harmony default export */ var mixins_loginData = (loginData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/header.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var header = ({
  components: {
    sidebarMain: components_sidebar_main
  },
  mixins: [toastMethods["a" /* default */], responsitive["a" /* default */], src_mixins_locale, mixins_loginData],
  data: function data() {
    return {
      currentMenu: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isLogin', 'user']), {
    // global
    externalLinkDatas: function externalLinkDatas() {
      return data_externalLinkDatas;
    }
  }),
  watch: {
    '$route': function $route() {
      this.currentMenu = null;
    },
    'afkCountDown.value': function afkCountDownValue(nv) {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35bdf5b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/header.vue
var header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('transition',{attrs:{"name":"mobile-menu"}},[(_vm.currentMenu)?_c('div',{staticClass:"mobile-menu-field col-block width-full",on:{"click":function (e) { return _vm.currentMenu = null; }}},[(_vm.currentMenu === 'main')?[_c('div',{staticClass:"mobile-menu-container main row-block height-full",style:({ flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"mobile-menu-block",on:{"click":function($event){$event.stopPropagation();}}},[_c('sidebarMain',{attrs:{"type":'mobile'}})],1)])]:_vm._e()],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"header-field col-block width-full"},[_c('div',{staticClass:"header-container col-block width-full"},[_c('div',{staticClass:"header-block row-block"},[_c('div',{staticClass:"left-container row-block",style:({ flex: 1 })},[_c('a',{staticClass:"logo-container center-block",style:({ width: '180px' }),attrs:{"href":_vm.externalLinkDatas()['compassbioinfo'],"target":"_blank"}},[_c('div',{staticClass:"logo-block row-block"},[_c('div',{staticClass:"logo-icon center-block"},[_c('img',{style:({ 'max-width': '24px' }),attrs:{"src":__webpack_require__("BA3z"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"logo-title"},[_vm._v(_vm._s(_vm.$t('LAYOUT.header.___logoTitle')))])])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"center-container"}),_vm._v(" "),_c('div',{staticClass:"right-container row-block",style:({ flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"menu-icon-button icon-block",style:({ '--size': '40px' }),on:{"click":function (e) { return _vm.currentMenu = (_vm.isMobile && !_vm.currentMenu ? 'main' : null); }}},[_c('img',{style:({ 'max-width': '30px' }),attrs:{"src":_vm.currentMenu === 'main' ? __webpack_require__("BBXg") : __webpack_require__("/jCf"),"alt":""}})])])])])])],1)}
var header_staticRenderFns = []
var header_esExports = { render: header_render, staticRenderFns: header_staticRenderFns }
/* harmony default export */ var layout_header = (header_esExports);
// CONCATENATED MODULE: ./src/components/layout/header.vue
var header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var header___vue_template_functional__ = false
/* styles */
var header___vue_styles__ = null
/* scopeId */
var header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var header___vue_module_identifier__ = null
var header_Component = header_normalizeComponent(
  header,
  layout_header,
  header___vue_template_functional__,
  header___vue_styles__,
  header___vue_scopeId__,
  header___vue_module_identifier__
)

/* harmony default export */ var components_layout_header = (header_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/joinComponent.vue
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var joinComponent = ({
  props: {
    type: {
      type: String,
      default: function _default() {
        return 'column';
      }
    },
    gap: {
      type: String,
      default: function _default() {
        return '0px';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fce11ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/joinComponent.vue
var joinComponent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"join-component",class:[{ 'column': 'col-block', 'row': 'row-block' }[_vm.type]],style:({ gap: _vm.gap })},[_vm._l((Object.keys(_vm.$slots).filter(function (n) { return !['separator'].includes(n); })),function(n,i){return [(i)?[(_vm.$slots['separator'])?_vm._t('separator'):_c('hr',{key:'separator-' + i})]:_vm._e(),_vm._v(" "),_vm._t(n)]})],2)}
var joinComponent_staticRenderFns = []
var joinComponent_esExports = { render: joinComponent_render, staticRenderFns: joinComponent_staticRenderFns }
/* harmony default export */ var tool_joinComponent = (joinComponent_esExports);
// CONCATENATED MODULE: ./src/components/tool/joinComponent.vue
var joinComponent_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var joinComponent___vue_template_functional__ = false
/* styles */
var joinComponent___vue_styles__ = null
/* scopeId */
var joinComponent___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var joinComponent___vue_module_identifier__ = null
var joinComponent_Component = joinComponent_normalizeComponent(
  joinComponent,
  tool_joinComponent,
  joinComponent___vue_template_functional__,
  joinComponent___vue_styles__,
  joinComponent___vue_scopeId__,
  joinComponent___vue_module_identifier__
)

/* harmony default export */ var components_tool_joinComponent = (joinComponent_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/footer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var footer = ({
  components: {
    joinComponent: components_tool_joinComponent
  },
  mixins: [responsitive["a" /* default */], src_mixins_locale],
  data: function data() {
    return {
      selectedAdress: 'JP'
    };
  },

  computed: {
    // static
    infoListOptions: function infoListOptions() {
      return [{
        options: [{
          icon: {
            src: __webpack_require__("BA3z"),
            width: '16px'
          },
          content: {
            text: this.$t('LAYOUT.footer.___companyTitle')
          },
          custom: this.isMobile ? 'language' : ''
        }]
      }, {
        options: [{
          title: 'US',
          titleStyle: this.selectedAdress === 'US' && this.isMobile ? { color: '#003679' } : {},
          content: this.selectedAdress === 'US' || !this.isMobile ? {
            text: '13400 Briarwick Drive, Unit 103, Austin, TX 78728'
          } : null
        }, {
          title: 'TW',
          titleStyle: this.selectedAdress === 'TW' && this.isMobile ? { color: '#003679' } : {},
          content: this.selectedAdress === 'TW' || !this.isMobile ? {
            text: '新竹市東區慈雲路118號17樓之10'
          } : null
        }, {
          title: 'JP',
          titleStyle: this.selectedAdress === 'JP' && this.isMobile ? { color: '#003679' } : {},
          content: this.selectedAdress === 'JP' || !this.isMobile ? {
            text: '東京都港区西新橋一丁目6番12号アイオス虎ノ門803室'
          } : null
        }]
      }, {
        options: [{
          title: 'Phone',
          content: {
            text: '+886 3-5745009'
          }
        }, {
          title: 'Email',
          content: {
            text: 'service@compassbioinfo.com',
            link: 'mailto:service@compassbioinfo.com'
          }
        }].concat(toConsumableArray_default()(!this.isMobile ? [{
          title: 'Language',
          custom: 'language'
        }] : []))
      }];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54737d20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/footer.vue
var footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer col-block"},_vm._l((_vm.infoListOptions),function(infoOptions,iloindex){return _c('div',{key:iloindex,staticClass:"info-list-container col-block"},[_c('joinComponent',{attrs:{"type":'row',"gap":'0.3rem'}},[_c('span',{attrs:{"slot":"separator"},slot:"separator"},[_vm._v("|")]),_vm._v(" "),_vm._l((infoOptions.options),function(infoOption,ioindex){return _c('div',{key:ioindex,staticClass:"info-list-block row-block",attrs:{"slot":'slot-' + (ioindex + 1)},slot:'slot-' + (ioindex + 1)},[(infoOption.icon)?_c('div',{staticClass:"info-icon center-block"},[_c('img',{style:(infoOption.icon.width ? { 'max-width': infoOption.icon.width } : {}),attrs:{"src":infoOption.icon.src,"alt":""}})]):_vm._e(),_vm._v(" "),(infoOption.title)?_c('div',{staticClass:"info-title",style:(infoOption.titleStyle),domProps:{"innerHTML":_vm._s(infoOption.title)},on:{"click":function (e) { return _vm.selectedAdress = infoOption.title; }}}):_vm._e(),_vm._v(" "),(infoOption.content)?_c(infoOption.content.link ? 'a' : 'div',{tag:"component",staticClass:"info-content link main no-line",attrs:{"href":infoOption.content.link}},[_vm._v(_vm._s(infoOption.content.text))]):_vm._e(),_vm._v(" "),(infoOption.custom === 'language')?[_c('div',{staticClass:"info-language-container row-block"},[_c('div',{staticClass:"info-language-block row-block"},[(!infoOption.title)?_c('span',[_vm._v("[")]):_vm._e(),_vm._v(" "),_vm._l((_vm.languageOptions),function(option,loindex){return _c('div',{key:loindex,staticClass:"info-language-content-container row-block",class:{ active: option.value === _vm.locale },on:{"click":function (e) { return _vm.setLang(option.value); }}},[_c('div',{staticClass:"info-language-content"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(_vm.languageOptions[loindex + 1])?_c('span',[_vm._v("-")]):_vm._e()])}),_vm._v(" "),(!infoOption.title)?_c('span',[_vm._v("]")]):_vm._e()],2)])]:_vm._e()],2)})],2)],1)}),0)}
var footer_staticRenderFns = []
var footer_esExports = { render: footer_render, staticRenderFns: footer_staticRenderFns }
/* harmony default export */ var layout_footer = (footer_esExports);
// CONCATENATED MODULE: ./src/components/layout/footer.vue
var footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var footer___vue_template_functional__ = false
/* styles */
var footer___vue_styles__ = null
/* scopeId */
var footer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var footer___vue_module_identifier__ = null
var footer_Component = footer_normalizeComponent(
  footer,
  layout_footer,
  footer___vue_template_functional__,
  footer___vue_styles__,
  footer___vue_scopeId__,
  footer___vue_module_identifier__
)

/* harmony default export */ var components_layout_footer = (footer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/toast.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var layout_toast = ({
  data: function data() {
    return {
      toasts: [],
      removeTimer: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['toast'])),
  watch: {
    'toast': function toast(nv) {
      var _this = this;

      var id = new Date().getTime() + '';
      this.toasts.push(extends_default()({}, nv, {
        id: id,
        clearTimer: null,
        timer: setTimeout(function () {
          _this.toasts.splice(_this.toasts.indexOf(_this.toasts.find(function (toast) {
            return toast.id === id;
          })), 1);
        }, 5000)
      }));
    }
  },
  methods: {
    keepToast: function keepToast(toast) {
      toast.clearTimer = setTimeout(function () {
        clearTimeout(toast.timer);
        toast.clearTimer = null;
      }, 500);
    },
    leaveToast: function leaveToast(toast, index) {
      if (toast.clearTimer) {
        clearTimeout(toast.clearTimer);
      } else {
        this.removeToast(index);
      }
    },
    removeToast: function removeToast(index) {
      var _this2 = this;

      if (this.removeTimer) return;
      this.removeTimer = setTimeout(function () {
        _this2.toasts.splice(index, 1);
        setTimeout(function () {
          _this2.removeTimer = null;
        }, 400);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dd4bc6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/toast.vue
var toast_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast-position"},[_c('div',{staticClass:"toast-container"},[_c('transition-group',{staticClass:"toast-list col-block",attrs:{"tag":"div","name":"toast-list"}},_vm._l((_vm.toasts),function(toast,index){return _c('div',{key:toast.id,staticClass:"toast col-block",class:[toast.type],on:{"mouseenter":function (e) { return _vm.keepToast(toast); },"mouseleave":function (e) { return _vm.leaveToast(toast, index); }}},[_c('div',{staticClass:"option"},[_c('img',{attrs:{"src":__webpack_require__("nzHv"),"alt":""},on:{"click":function (e) { return _vm.removeToast(index); }}})]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(toast.title || { error: _vm.$t('LAYOUT.dialog.toast.title.___error'/* Error */) + ' !', success: _vm.$t('LAYOUT.dialog.toast.title.___success'/* Success */) + ' !' }[toast.type]))]),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(toast.content)}})])}),0)],1)])}
var toast_staticRenderFns = []
var toast_esExports = { render: toast_render, staticRenderFns: toast_staticRenderFns }
/* harmony default export */ var components_layout_toast = (toast_esExports);
// CONCATENATED MODULE: ./src/components/layout/toast.vue
var toast_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var toast___vue_template_functional__ = false
/* styles */
var toast___vue_styles__ = null
/* scopeId */
var toast___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var toast___vue_module_identifier__ = null
var toast_Component = toast_normalizeComponent(
  layout_toast,
  components_layout_toast,
  toast___vue_template_functional__,
  toast___vue_styles__,
  toast___vue_scopeId__,
  toast___vue_module_identifier__
)

/* harmony default export */ var src_components_layout_toast = (toast_Component.exports);

// EXTERNAL MODULE: ./src/components/tool/borCor.vue + 2 modules
var tool_borCor = __webpack_require__("HALv");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/borCor.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// borCor

/* harmony default export */ var layout_borCor = ({
  components: {
    borCorCP: tool_borCor["a" /* default */]
    // borCor
  },
  data: function data() {
    return {
      borCorData: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['borCor'])),
  watch: {
    'borCor': function borCor(nv) {
      this.borCorData = nv ? extends_default()({}, nv, {
        triggerData: nv.e.target.getBoundingClientRect()
      }) : null;
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setBorCorAction']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b43b9da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/borCor.vue
var borCor_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bor-cor-page",style:(_vm.borCorData ? {
    top: _vm.borCorData.triggerData.top + 'px',
    left: _vm.borCorData.triggerData.left + 'px'
  } : {})},[(_vm.borCorData)?_c('borCorCP',_vm._b({on:{"leave":function () { return _vm.setBorCorAction(); }}},'borCorCP',_vm.borCorData.options || {},false),[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"bor-cor-container",style:({
          width: _vm.borCorData.triggerData.width + 'px',
          height: _vm.borCorData.triggerData.height + 'px'
        })})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[((_vm.borCorData.content || {}).html)?_c('div',{domProps:{"innerHTML":_vm._s((_vm.borCorData.content || {}).html)}}):((_vm.borCorData.content || {}).component)?_c((_vm.borCorData.content || {}).component,{tag:"component",attrs:{"param":(_vm.borCorData.content || {}).param}}):_vm._e()],1)]):_vm._e()],1)}
var borCor_staticRenderFns = []
var borCor_esExports = { render: borCor_render, staticRenderFns: borCor_staticRenderFns }
/* harmony default export */ var components_layout_borCor = (borCor_esExports);
// CONCATENATED MODULE: ./src/components/layout/borCor.vue
var borCor_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var borCor___vue_template_functional__ = false
/* styles */
var borCor___vue_styles__ = null
/* scopeId */
var borCor___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var borCor___vue_module_identifier__ = null
var borCor_Component = borCor_normalizeComponent(
  layout_borCor,
  components_layout_borCor,
  borCor___vue_template_functional__,
  borCor___vue_styles__,
  borCor___vue_scopeId__,
  borCor___vue_module_identifier__
)

/* harmony default export */ var src_components_layout_borCor = (borCor_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/loading.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4e7d800","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/loading.vue
var loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-page"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":__webpack_require__("SE3R"),"alt":""}})])])}
var loading_staticRenderFns = []
var loading_esExports = { render: loading_render, staticRenderFns: loading_staticRenderFns }
/* harmony default export */ var layout_loading = (loading_esExports);
// CONCATENATED MODULE: ./src/components/layout/loading.vue
var loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loading___vue_template_functional__ = false
/* styles */
var loading___vue_styles__ = null
/* scopeId */
var loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loading___vue_module_identifier__ = null
var loading_Component = loading_normalizeComponent(
  loading,
  layout_loading,
  loading___vue_template_functional__,
  loading___vue_styles__,
  loading___vue_scopeId__,
  loading___vue_module_identifier__
)

/* harmony default export */ var components_layout_loading = (loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/uploading.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var uploading = ({
  props: {
    content: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65c038ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/uploading.vue
var uploading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uploading-page"},[_c('div',{staticClass:"img-box"},[_c('h1',{attrs:{"title":_vm.content !== null ? _vm.content : _vm.$t('LAYOUT.uploading.___default'/* 檔案上傳中 */)}},[_vm._v(_vm._s(_vm.content !== null ? _vm.content : _vm.$t('LAYOUT.uploading.___default'/* 檔案上傳中 */)))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("SE3R"),"alt":""}})])])}
var uploading_staticRenderFns = []
var uploading_esExports = { render: uploading_render, staticRenderFns: uploading_staticRenderFns }
/* harmony default export */ var layout_uploading = (uploading_esExports);
// CONCATENATED MODULE: ./src/components/layout/uploading.vue
var uploading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var uploading___vue_template_functional__ = false
/* styles */
var uploading___vue_styles__ = null
/* scopeId */
var uploading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var uploading___vue_module_identifier__ = null
var uploading_Component = uploading_normalizeComponent(
  uploading,
  layout_uploading,
  uploading___vue_template_functional__,
  uploading___vue_styles__,
  uploading___vue_scopeId__,
  uploading___vue_module_identifier__
)

/* harmony default export */ var components_layout_uploading = (uploading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/loading.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var dialog_loading = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52e4f089","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/loading.vue
var dialog_loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-dialog"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":__webpack_require__("SE3R"),"alt":""}})])])}
var dialog_loading_staticRenderFns = []
var dialog_loading_esExports = { render: dialog_loading_render, staticRenderFns: dialog_loading_staticRenderFns }
/* harmony default export */ var components_dialog_loading = (dialog_loading_esExports);
// CONCATENATED MODULE: ./src/components/dialog/loading.vue
var dialog_loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dialog_loading___vue_template_functional__ = false
/* styles */
var dialog_loading___vue_styles__ = null
/* scopeId */
var dialog_loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dialog_loading___vue_module_identifier__ = null
var dialog_loading_Component = dialog_loading_normalizeComponent(
  dialog_loading,
  components_dialog_loading,
  dialog_loading___vue_template_functional__,
  dialog_loading___vue_styles__,
  dialog_loading___vue_scopeId__,
  dialog_loading___vue_module_identifier__
)

/* harmony default export */ var src_components_dialog_loading = (dialog_loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/container.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var container = ({
  components: {
    dialogLoading: src_components_dialog_loading
  },
  mixins: [responsitive["a" /* default */]],
  props: {
    action: {
      type: String,
      default: function _default() {
        return null;
      }
    },
    type: {
      type: String,
      default: function _default() {
        return 'default';
      }
    },
    width: {
      type: String,
      default: function _default() {
        return null;
      }
    },
    height: {
      type: String,
      default: function _default() {
        return null;
      }
    },
    customStyles: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    maskClose: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    autoHeight: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      onClose: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isDialogLoading']), {
    containerStyle: function containerStyle() {
      var defaultStyle = {
        'default': {
          height: this.height || 'auto',
          width: this.width || '400px'
        },
        'slide-left': {
          height: null,
          width: this.width || '80%'
        },
        'slide-right': {
          height: null,
          width: this.width || '80%'
        }
      }[this.type];
      return extends_default()({}, this.customStyles, defaultStyle);
    }
  }),
  methods: {
    closeModal: function closeModal() {
      if (this.maskClose) {
        this.$emit('hide');
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9c57e88","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/container.vue
var container_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[(_vm.action)?_c('div',{staticClass:"modal-mask",class:{ 'row-block': _vm.isMobile, 'mobile': _vm.isMobile },on:{"click":function($event){$event.stopPropagation();return (function (e) { return _vm.closeModal(); })($event)}}},[_c('div',{staticClass:"modal-wrapper col-block",class:[{ 'auto-height': _vm.autoHeight }, _vm.type]},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"modal-container",style:(_vm.containerStyle),on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default"),_vm._v(" "),(_vm.isDialogLoading)?_c('dialogLoading'):_vm._e()],2),_vm._v(" "),_c('div',{style:({ flex: 2, 'min-height': '0.1px', 'width': '100%' })})])]):_vm._e()])}
var container_staticRenderFns = []
var container_esExports = { render: container_render, staticRenderFns: container_staticRenderFns }
/* harmony default export */ var dialog_container = (container_esExports);
// CONCATENATED MODULE: ./src/components/dialog/container.vue
function injectStyle (ssrContext) {
  __webpack_require__("dsSz")
}
var container_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var container___vue_template_functional__ = false
/* styles */
var container___vue_styles__ = injectStyle
/* scopeId */
var container___vue_scopeId__ = "data-v-f9c57e88"
/* moduleIdentifier (server only) */
var container___vue_module_identifier__ = null
var container_Component = container_normalizeComponent(
  container,
  dialog_container,
  container___vue_template_functional__,
  container___vue_styles__,
  container___vue_scopeId__,
  container___vue_module_identifier__
)

/* harmony default export */ var components_dialog_container = (container_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/selectIdentity.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var selectIdentity = ({
  mixins: [responsitive["a" /* default */]],
  computed: {
    // static
    selectOptions: function selectOptions() {
      return [{
        title: this.$t('LAYOUT.dialog.selectIdentity.option.___patient'),
        value: 'patient'
      }, {
        title: this.$t('LAYOUT.dialog.selectIdentity.option.___doctor'),
        value: 'doctor'
      }];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48d89fca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/selectIdentity.vue
var selectIdentity_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-identity-dialog col-block width-full"},[_c('div',{staticClass:"select-identity-title-container col-block"},[_c('div',{staticClass:"select-identity-title"},[_vm._v(_vm._s(_vm.$t('LAYOUT.dialog.selectIdentity.___title')))])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"select-identity-option-list-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"select-identity-option-list-block",class:_vm.isMobile ? ['col-block'] : ['row-block']},_vm._l((_vm.selectOptions),function(option,soindex){return _c('div',{key:soindex,staticClass:"select-identity-option-container center-block",on:{"click":function (e) { return _vm.$emit('changeModal', {}, option.value); }}},[_c('div',{staticClass:"select-identity-option-title",domProps:{"innerHTML":_vm._s(option.title)}})])}),0),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"select-identity-button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-outline-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var selectIdentity_staticRenderFns = []
var selectIdentity_esExports = { render: selectIdentity_render, staticRenderFns: selectIdentity_staticRenderFns }
/* harmony default export */ var dialog_selectIdentity = (selectIdentity_esExports);
// CONCATENATED MODULE: ./src/components/dialog/selectIdentity.vue
var selectIdentity_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var selectIdentity___vue_template_functional__ = false
/* styles */
var selectIdentity___vue_styles__ = null
/* scopeId */
var selectIdentity___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var selectIdentity___vue_module_identifier__ = null
var selectIdentity_Component = selectIdentity_normalizeComponent(
  selectIdentity,
  dialog_selectIdentity,
  selectIdentity___vue_template_functional__,
  selectIdentity___vue_styles__,
  selectIdentity___vue_scopeId__,
  selectIdentity___vue_module_identifier__
)

/* harmony default export */ var components_dialog_selectIdentity = (selectIdentity_Component.exports);

// EXTERNAL MODULE: ./src/components/phenotypeDisease/network.vue + 8 modules
var network = __webpack_require__("e4hu");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/phenotypeMore.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var phenotypeMore = ({
  components: {
    phenotypeDiseaseNetwork: network["a" /* default */]
  },
  mixins: [responsitive["a" /* default */]],
  props: {
    param: {
      type: Object,
      required: true
    }
  },
  computed: {
    // static
    tableOptions: function tableOptions() {
      return [{
        title: this.$t('PAGE.phenotypeDisease.table.title.___gene'),
        value: 'gene',
        grid: 2,
        class: 'center'
      }, {
        title: this.$t('PAGE.phenotypeDisease.table.title.___disease'),
        value: 'disease_name',
        grid: 7
      }, {
        title: this.$t('PAGE.phenotypeDisease.table.title.___phenotype'),
        value: '_HPO',
        grid: 9
      }];
    },

    // global
    data: function data() {
      return this.param.data;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1550cb74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/phenotypeMore.vue
var phenotypeMore_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phenotype-more-dialog col-block width-full"},[_c('div',{staticClass:"phenotype-more-title-container col-block flex-start"},[_c('div',{staticClass:"phenotype-more-title"},[_vm._v(_vm._s(_vm.$t('LAYOUT.dialog.phenotypeMore.___title')))])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"phenotype-more-table-container col-block width-full"},[_c('div',{staticClass:"phenotype-more-table-block",style:({
        flex: 1,
        'grid-template-columns': '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr'
      })},_vm._l((_vm.tableOptions),function(option,toindex){return _c('div',{key:toindex,staticClass:"phenotype-more-table-content-container col-block width-full",class:option.class,style:({
          'grid-column': 'span ' + option.grid
        })},[_c('div',{staticClass:"phenotype-more-table-head-container col-block width-full"},[_c('div',{staticClass:"phenotype-more-table-head-block col-block width-full"},[_c('div',{staticClass:"phenotype-more-table-head"},[_vm._v(_vm._s(option.title))])])]),_vm._v(" "),_c('div',{staticClass:"phenotype-more-table-body-container col-block width-full"},[(option.value === '_HPO')?[_c('div',{staticClass:"phenotype-more-table-network-container",style:({ flex: 1, 'max-height': (_vm.windowHeight / 2) + 'px', 'min-height': (_vm.windowHeight / 4) + 'px' })},[_c('phenotypeDiseaseNetwork',{style:({ width: '550px' }),attrs:{"hpoNetworks":_vm.data.hpo_network}})],1)]:[_c('div',{staticClass:"phenotype-more-table-body-block col-block width-full"},[_c('div',{staticClass:"phenotype-more-table-body"},[_vm._v(_vm._s(_vm.data[option.value]))])])]],2),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"phenotype-more-button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"main-button2 circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___back')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var phenotypeMore_staticRenderFns = []
var phenotypeMore_esExports = { render: phenotypeMore_render, staticRenderFns: phenotypeMore_staticRenderFns }
/* harmony default export */ var dialog_phenotypeMore = (phenotypeMore_esExports);
// CONCATENATED MODULE: ./src/components/dialog/phenotypeMore.vue
var phenotypeMore_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var phenotypeMore___vue_template_functional__ = false
/* styles */
var phenotypeMore___vue_styles__ = null
/* scopeId */
var phenotypeMore___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var phenotypeMore___vue_module_identifier__ = null
var phenotypeMore_Component = phenotypeMore_normalizeComponent(
  phenotypeMore,
  dialog_phenotypeMore,
  phenotypeMore___vue_template_functional__,
  phenotypeMore___vue_styles__,
  phenotypeMore___vue_scopeId__,
  phenotypeMore___vue_module_identifier__
)

/* harmony default export */ var components_dialog_phenotypeMore = (phenotypeMore_Component.exports);

// EXTERNAL MODULE: ./src/components/resourceMap/data.vue + 2 modules
var resourceMap_data = __webpack_require__("OGMH");

// EXTERNAL MODULE: ./src/components/tool/googleMap.vue + 2 modules
var googleMap = __webpack_require__("4G+f");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/resourceMap.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var resourceMap = ({
  components: {
    resourceMapData: resourceMap_data["a" /* default */],
    googleMap: googleMap["a" /* default */]
  },
  mixins: [responsitive["a" /* default */]],
  props: {
    param: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      selectedMapData: this.param.selectedMapData
    };
  },

  computed: {
    markerOptions: function markerOptions() {
      var _this = this;

      return this.resoucreMapDatas.map(function (data) {
        return {
          position: { lat: data.latitude - 0, lng: data.longitude - 0 },
          icon: data.id === _this.selectedMapData.id ? __webpack_require__("nCot") : __webpack_require__("9zQ9"),
          zIndex: data.id === _this.selectedMapData.id ? 1 : 0,
          optimized: false
        };
      });
    },

    // param
    resoucreMapDatas: function resoucreMapDatas() {
      return this.param.resoucreMapDatas;
    }
  },
  methods: {
    // google map
    markerEvent: function markerEvent(event, marker, map) {
      if (event === 'click') {
        var position = marker.getPosition();
        var mapData = {
          center: map.getCenter(),
          zoom: map.getZoom()
        };
        var data = this.resoucreMapDatas.find(function (data) {
          return data.latitude - 0 === position.lat() && data.longitude - 0 === position.lng();
        });
        this.selectedMapData = data || this.selectedMapData;
        map.setCenter(mapData.center);
        map.setZoom(mapData.zoom);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86ede4c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/resourceMap.vue
var resourceMap_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedMapData)?_c('div',{staticClass:"resource-map-dialog col-block width-full"},[_c('div',{staticClass:"resource-map-data-container col-block width-full"},[_c('resourceMapData',{key:_vm.selectedMapData.id,attrs:{"data":_vm.selectedMapData,"active":true,"selectable":false}})],1),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"resoure-map-map-container",style:({ height: (_vm.windowHeight / 2) + 'px' })},[_c('googleMap',{attrs:{"position":{ lat: _vm.selectedMapData.latitude - 0, lng: _vm.selectedMapData.longitude - 0 },"mapOption":{
        zoom: 10,
        zoomControl: false,
        streetViewControl: false,
        scaleControl: false,
        rotateControl: false,
        panControl: false,
        mapTypeControl: false,
        fullscreenControl: false
      },"markerOptions":_vm.markerOptions},on:{"markerEvent":function (event, marker, map) { return _vm.markerEvent(event, marker, map); }}})],1),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"resource-map-button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"main-button2 circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___back')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]):_vm._e()}
var resourceMap_staticRenderFns = []
var resourceMap_esExports = { render: resourceMap_render, staticRenderFns: resourceMap_staticRenderFns }
/* harmony default export */ var dialog_resourceMap = (resourceMap_esExports);
// CONCATENATED MODULE: ./src/components/dialog/resourceMap.vue
var resourceMap_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var resourceMap___vue_template_functional__ = false
/* styles */
var resourceMap___vue_styles__ = null
/* scopeId */
var resourceMap___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var resourceMap___vue_module_identifier__ = null
var resourceMap_Component = resourceMap_normalizeComponent(
  resourceMap,
  dialog_resourceMap,
  resourceMap___vue_template_functional__,
  resourceMap___vue_styles__,
  resourceMap___vue_scopeId__,
  resourceMap___vue_module_identifier__
)

/* harmony default export */ var components_dialog_resourceMap = (resourceMap_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/toast.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var dialog_toast = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c9faf86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/toast.vue
var dialog_toast_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-toast col-block",class:_vm.param.type},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.param.content)}}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_vm._l((_vm.param.buttons || []),function(button,index){return _c('button',{key:index,class:[button.type + '-button', 'circle-button'],on:{"click":function($event){_vm.$emit('changeModal', {}, button.result)}}},[_c('span',[_vm._v(_vm._s(button.title))])])}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)])}
var dialog_toast_staticRenderFns = []
var dialog_toast_esExports = { render: dialog_toast_render, staticRenderFns: dialog_toast_staticRenderFns }
/* harmony default export */ var components_dialog_toast = (dialog_toast_esExports);
// CONCATENATED MODULE: ./src/components/dialog/toast.vue
var dialog_toast_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dialog_toast___vue_template_functional__ = false
/* styles */
var dialog_toast___vue_styles__ = null
/* scopeId */
var dialog_toast___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dialog_toast___vue_module_identifier__ = null
var dialog_toast_Component = dialog_toast_normalizeComponent(
  dialog_toast,
  components_dialog_toast,
  dialog_toast___vue_template_functional__,
  dialog_toast___vue_styles__,
  dialog_toast___vue_scopeId__,
  dialog_toast___vue_module_identifier__
)

/* harmony default export */ var src_components_dialog_toast = (dialog_toast_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















// modals






__webpack_require__("5W8o");

/* harmony default export */ var App = ({
  name: 'app',
  components: {
    layoutSidebar: components_layout_sidebar,
    layoutHeader: components_layout_header,
    layoutFooter: components_layout_footer,
    layoutToast: src_components_layout_toast,
    layoutBorCor: src_components_layout_borCor,
    layoutLoading: components_layout_loading,
    layoutUploading: components_layout_uploading,
    // modals
    modal: components_dialog_container,
    selectIdentity: components_dialog_selectIdentity,
    phenotypeMore: components_dialog_phenotypeMore,
    resourceMap: components_dialog_resourceMap,
    toast: src_components_dialog_toast
  },
  mixins: [responsitive["a" /* default */], toastMethods["a" /* default */], src_mixins_locale, mixins_loginData],
  metaInfo: function metaInfo() {
    return {
      title: this.$t('LAYOUT.header.___webTitle' /* 網頁標題 */)
    };
  },
  data: function data() {
    return {
      userAgent: '',
      afkCountDownTimer: null
    };
  },

  watch: {
    '$route': function $route() {
      var _document = document,
          body = _document.body;

      body.scroll(0, 0);
      document.getElementById('app').scroll(0, 0);
      this.setModalAction({});
      this.setModal2Action({});
      this.clearSubLoadingAction();
      this.setAFKCountDown();
      window.dispatchEvent(new Event('resize'));
      if (this.initial !== null) {
        var user = this.user || {};
        this.setLoadingAction(true);
        this.validateRoute(this.isLogin, user.role, user.admin);
      }
    },
    'isLogin': function isLogin(n, o) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setAFKCountDown();

                if (!(o !== null)) {
                  _context.next = 13;
                  break;
                }

                _this.setLoadingAction(true);
                _context.next = 5;
                return _this.preFetchDataGuest();

              case 5:
                if (!n) {
                  _context.next = 10;
                  break;
                }

                _context.next = 8;
                return _this.preFetchData();

              case 8:
                _context.next = 11;
                break;

              case 10:
                _this.setUnloadAlertAction();

              case 11:
                _this.appInitialAction(n);
                _this.setLoadingAction(false);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    'unloadAlert': function unloadAlert(nv) {
      if (nv) {
        window.document.body.onbeforeunload = function () {
          return '';
        };
      } else {
        window.document.body.onbeforeunload = null;
      }
    },
    'loading': function loading(nv) {
      this.setAFKCountDownAction({ active: !nv });
    },
    'isUploading': function isUploading(nv) {
      this.setAFKCountDownAction({ active: nv === undefined });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user', 'normalPage', 'userPage', 'adminPage', 'initial', 'isLogin', 'isLoading', 'isDialogLoading', 'isUploading', 'modal', 'modal2', 'unloadAlert', 'afkCountDown']), {
    minHeight: function minHeight() {
      return this.windowHeight - this.headerHeight - this.footerHeight;
    },
    currentBackground: function currentBackground() {
      var currentBackground = {}[this.$route.name];
      return currentBackground ? extends_default()({ 'background-image': 'url(' + currentBackground.url + ')' }, currentBackground.style) : null;
    },
    isReportPage: function isReportPage() {
      return this.$route.name && ['report',
      //
      ''].includes(this.$route.name);
    }
  }),
  created: function created() {
    var _this2 = this;

    this.userAgent = navigator.userAgent;
    this.setLocale();
    this.setModalAction({});
    this.setModal2Action({});
    this.setLoadingAction(true);
    this.setAFKCountDown();
    var validateLogin = function validateLogin() {
      if (_this2.$route.name) {
        _this2.validateLogin();
      } else {
        setTimeout(function () {
          return validateLogin();
        }, 100);
      }
    };
    validateLogin();
  },
  mounted: function mounted() {
    var _this3 = this;

    window.addEventListener('scroll', function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      var offsetHeight = document.documentElement.offsetHeight || document.body.offsetHeight;
      _this3.setScrollStateAction({
        top: scrollTop,
        height: scrollHeight - offsetHeight
      });
    });
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['appInitialAction', 'setLoadingAction', 'setDialogLoadingAction', 'clearLoadingAction', 'clearSubLoadingAction', 'clearDialogLoadingAction', 'setModalAction', 'setModal2Action', 'setUnloadAlertAction', 'setScrollStateAction', 'setAFKCountDownAction'
  // global
  ]), {
    setLocale: function setLocale() {
      var langMap = function langMap(l) {
        if (!l) return null;
        l = l.toLowerCase();
        // if (l === 'zh-cn') return 'tc'
        // if (l.startsWith('zh')) return 'tc'
        if (l === 'ja') return 'ja';
        return 'en';
      };
      var locale = localStorage.getItem('locale');
      if (!this.languageOptions.map(function (option) {
        return option.value;
      }).includes(locale)) {
        locale = langMap(window.navigator.language || navigator.userLanguage) || 'en';
      }
      this.setLang(locale);
    },
    preFetchDataGuest: function preFetchDataGuest() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    preFetchData: function preFetchData() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    validateLogin: function validateLogin() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var userInfo;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                userInfo = _this6.$ls.get('userInfo') || {};
                _context4.next = 3;
                return _this6.preFetchDataGuest();

              case 3:
                if (!userInfo['access-token']) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 6;
                return _this6.getUserByToken(userInfo);

              case 6:
                _context4.next = 11;
                break;

              case 8:
                _this6.setUserData(null);
                _this6.appInitialAction(false);
                _this6.validateRoute(false);

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    getUserByToken: function getUserByToken(data) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var response, user;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return Object(api["f" /* getUserToken */])(data);

              case 3:
                response = _context5.sent;
                _context5.next = 6;
                return _this7.preFetchData();

              case 6:
                user = _this7.setUserData(response, data) || { role: {} };

                _this7.appInitialAction(true);
                _this7.validateRoute(true, user.role, user.admin);
                _context5.next = 17;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5['catch'](0);

                _this7.setUserData(null);
                _this7.appInitialAction(true);
                _this7.addToast('error', !_context5.t0.response ? _context5.t0.message : _context5.t0.response.data.result.message);
                _this7.validateRoute(false);

              case 17:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[0, 11]]);
      }))();
    },
    validateRoute: function validateRoute(isLogin, role, admin) {
      var array = [];
      if (isLogin) {
        switch (role) {
          default:
            {
              array = lodash_default.a.union(this.userPage, this.normalPage);
            }
        }
      } else {
        array = this.normalPage;
      }
      if (admin) {
        array = lodash_default.a.union(array, this.adminPage);
      }
      this.validateRole(isLogin, array);
    },
    validateRole: function validateRole(isLogin, pages) {
      var routeName = this.$route.name;
      if (routeName && !lodash_default.a.includes(pages, routeName)) {
        this.addToast('error', isLogin ? this.$t('COMMON.toast.___noPermission' /* 權限不足 */) : this.$t('COMMON.toast.___pleaseLogin' /* 請先登入 */));
        this.$router.push(isLogin ? { name: 'main' } : { name: 'main', query: { redirect: this.$route.fullPath } });
        this.setLoadingAction(false);
      } else {
        if (isLogin && lodash_default.a.includes(this.normalPage, routeName) && !['redirect'].includes(routeName)) {
          this.$router.push({ name: 'main' });
        }
        this.setLoadingAction(false);
      }
    },
    setAFKCountDown: function setAFKCountDown(value) {
      value = value || value === 0 ? value : this.afkCountDown.default;
      this.setAFKCountDownAction({ value: value });
      // if (!this.afkCountDownTimer) {
      //   this.afkCountDownTimer = setInterval(() => {
      //     this.setAFKCountDown(this.afkCountDown.active ? this.afkCountDown.value - this.afkCountDown.interval : this.afkCountDown.default)
      //   }, this.afkCountDown.interval)
      // }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-540ed3e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-root",style:({
    overflow: _vm.modal.action ? 'hidden' : 'auto',
    '--window-height': _vm.windowHeight + 'px',
    '--window-width': _vm.windowWidth + 'px',
    '--header-height': _vm.headerHeight + 'px',
    '--footer-height': _vm.footerHeight + 'px',
    '--scroll-size': _vm.scrollbarSize + 'px'
  }),attrs:{"id":"app"},on:{"mousemove":function (e) { return _vm.setAFKCountDown(); },"mousedown":function (e) { return _vm.setAFKCountDown(); },"mousewheel":function (e) { return _vm.setAFKCountDown(); },"keypress":function (e) { return _vm.setAFKCountDown(); }}},[_c('div',{attrs:{"id":"scroll-box"}}),_vm._v(" "),(_vm.isReportPage)?[_c('router-view')]:[(_vm.isMobile)?_c('layout-header'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-container row-block",style:({ position: _vm.modal.action && !_vm.isDialogLoading ? 'relative' : 'relative' }),attrs:{"id":"app-container"}},[(!_vm.isMobile)?_c('layout-sidebar',{attrs:{"minHeight":_vm.minHeight}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-pages col-block",style:({ flex: 1, height: _vm.minHeight + 'px' })},[(_vm.currentBackground)?_c('div',{staticClass:"app-background",style:(_vm.currentBackground)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-main-container col-block width-full",style:({ flex: 1, height: 0 })},[_c('router-view',{attrs:{"minHeight":_vm.minHeight}})],1),_vm._v(" "),_c('layout-footer')],1)],1),_vm._v(" "),_c('div',{staticClass:"modal-container"},[_c('modal',{style:(!_vm.isDialogLoading ? {} : { display: 'none' }),attrs:{"action":_vm.modal.action,"type":_vm.modal.type,"width":_vm.modal.width,"height":_vm.modal.height,"customStyles":_vm.modal.customStyles,"maskClose":_vm.modal.maskClose,"autoHeight":_vm.modal.autoHeight},on:{"hide":function () {
        _vm.modal.callback && _vm.modal.callback()
        _vm.setModalAction({})
      }}},[_c(_vm.modal.action,{tag:"component",attrs:{"param":_vm.modal.param},on:{"changeModal":function (option, param) {
          _vm.modal.callback && _vm.modal.callback(param)
          this$1.setModalAction(option || {})
        }}})],1),_vm._v(" "),_c('modal',{style:(!_vm.isDialogLoading ? {} : { display: 'none' }),attrs:{"action":_vm.modal2.action,"type":_vm.modal.type,"width":_vm.modal2.width,"height":_vm.modal2.height,"customStyles":_vm.modal2.customStyles,"maskClose":_vm.modal2.maskClose,"autoHeight":_vm.modal2.autoHeight},on:{"hide":function () {
        _vm.modal2.callback && _vm.modal2.callback()
        _vm.setModal2Action({})
      }}},[_c(_vm.modal2.action,{tag:"component",attrs:{"param":_vm.modal2.param},on:{"changeModal":function (option, param) {
          _vm.modal2.callback && _vm.modal2.callback(param)
          this$1.setModal2Action(option || {})
        }}})],1)],1),_vm._v(" "),_c('layoutToast'),_vm._v(" "),_c('layoutBorCor'),_vm._v(" "),(_vm.isLoading)?_c('layoutLoading'):_vm._e(),_vm._v(" "),(_vm.isUploading !== undefined)?_c('layoutUploading',{attrs:{"content":_vm.isUploading}}):_vm._e()]],2)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("WIZk")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router/index.js



vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes: [{
    path: '/',
    name: 'root',
    redirect: { name: 'phenotypeDisease' }
  }, {
    path: '/main',
    name: 'main',
    redirect: { name: 'phenotypeDisease' }
  }, {
    path: '/phenotypeDisease',
    name: 'phenotypeDisease',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("A/lE")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/genePanel',
    name: 'genePanel',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8HQS")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/resourceMap',
    name: 'resourceMap',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("qy57")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '*',
    redirect: { name: 'phenotypeDisease' }
  }]
}));
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/modules/app.js



var _mutations;

var app_state = {
  initial: null,
  isLogin: null,
  isLoading: 0,
  isSubLoading: 0,
  isDialogLoading: 0,
  isUploading: undefined,
  modal: {
    action: null,
    type: null,
    param: null,
    callback: null,
    height: null,
    width: null,
    autoHeight: null,
    closeButton: true,
    customStyles: {}
  },
  modal2: {
    action: null,
    type: null,
    param: null,
    callback: null,
    height: null,
    width: null,
    autoHeight: null,
    closeButton: true,
    customStyles: {}
  },
  toast: null,
  borCor: null,
  unloadAlert: 0,
  scrollState: {
    top: null,
    height: null
  },
  afkCountDown: {
    value: null,
    default: 30 * 60 * 1000,
    interval: 1000,
    active: true
  },
  // const
  normalPage: ['main', 'phenotypeDisease', 'genePanel', 'resourceMap'],
  userPage: [],
  adminPage: []
};

var getters = {
  initial: function initial(state) {
    return state.initial;
  },
  isLogin: function isLogin(state) {
    return state.isLogin;
  },
  isLoading: function isLoading(state) {
    return state.isLoading > 0;
  },
  isSubLoading: function isSubLoading(state) {
    return state.isSubLoading > 0;
  },
  isDialogLoading: function isDialogLoading(state) {
    return state.isDialogLoading > 0;
  },
  isUploading: function isUploading(state) {
    return state.isUploading;
  },
  modal: function modal(state) {
    return state.modal;
  },
  modal2: function modal2(state) {
    return state.modal2;
  },
  toast: function toast(state) {
    return state.toast;
  },
  borCor: function borCor(state) {
    return state.borCor;
  },
  unloadAlert: function unloadAlert(state) {
    return state.unloadAlert;
  },
  scrollState: function scrollState(state) {
    return state.scrollState;
  },
  afkCountDown: function afkCountDown(state) {
    return state.afkCountDown;
  },
  // const
  normalPage: function normalPage(state) {
    return state.normalPage;
  },
  userPage: function userPage(state) {
    return state.userPage;
  },
  adminPage: function adminPage(state) {
    return state.adminPage;
  }
};

var types = {
  appInitial: 'app/appInitial',
  setLogin: 'app/setLogin',
  setLoading: 'app/setLoading',
  clearLoading: 'app/clearLoading',
  setSubLoading: 'app/setSubLoading',
  clearSubLoading: 'app/clearSubLoading',
  setDialogLoading: 'app/setDialogLoading',
  clearDialogLoading: 'app/clearDialogLoading',
  setUploading: 'app/setUploading',
  setModal: 'app/setModal',
  setModal2: 'app/setModal2',
  addToast: 'app/addToast',
  setBorCor: 'app/setBorCor',
  setUnloadAlert: 'app/setUnloadAlert',
  setScrollState: 'app/setScrollState',
  setAFKCountDown: 'app/setAFKCountDown'
};

var mutations = (_mutations = {}, defineProperty_default()(_mutations, types.appInitial, function (state, boolean) {
  state.initial = boolean;
}), defineProperty_default()(_mutations, types.setLogin, function (state, boolean) {
  state.isLogin = boolean;
}), defineProperty_default()(_mutations, types.setLoading, function (state, boolean) {
  if (boolean !== undefined) {
    if (boolean) {
      state.isLoading += 1;
    } else {
      state.isLoading -= 1;
    }
  }
}), defineProperty_default()(_mutations, types.clearLoading, function (state) {
  state.isLoading = 0;
}), defineProperty_default()(_mutations, types.setSubLoading, function (state, boolean) {
  if (boolean !== undefined) {
    if (boolean) {
      state.isSubLoading += 1;
    } else {
      state.isSubLoading -= 1;
    }
  }
}), defineProperty_default()(_mutations, types.clearSubLoading, function (state) {
  state.isSubLoading = 0;
}), defineProperty_default()(_mutations, types.setDialogLoading, function (state, boolean) {
  if (boolean !== undefined) {
    if (boolean) {
      state.isDialogLoading += 1;
    } else {
      state.isDialogLoading -= 1;
    }
  }
}), defineProperty_default()(_mutations, types.clearDialogLoading, function (state) {
  state.isDialogLoading = 0;
}), defineProperty_default()(_mutations, types.setUploading, function (state, content) {
  state.isUploading = content;
}), defineProperty_default()(_mutations, types.setModal, function (state, object) {
  state.modal = object;
}), defineProperty_default()(_mutations, types.setModal2, function (state, object) {
  state.modal2 = object;
}), defineProperty_default()(_mutations, types.addToast, function (state, object) {
  state.toast = extends_default()({}, object);
}), defineProperty_default()(_mutations, types.setBorCor, function (state, object) {
  state.borCor = object;
}), defineProperty_default()(_mutations, types.setUnloadAlert, function (state, boolean) {
  if (boolean !== undefined) {
    if (boolean) {
      state.unloadAlert += 1;
    } else {
      state.unloadAlert -= 1;
    }
  } else {
    state.unloadAlert = 0;
  }
}), defineProperty_default()(_mutations, types.setScrollState, function (state, object) {
  state.scrollState = object;
}), defineProperty_default()(_mutations, types.setAFKCountDown, function (state, object) {
  state.afkCountDown = extends_default()({}, state.afkCountDown, object);
}), _mutations);

var actions = {
  appInitialAction: function appInitialAction(_ref, boolean) {
    var commit = _ref.commit;

    commit(types.appInitial, boolean);
  },
  setLoginAction: function setLoginAction(_ref2, boolean) {
    var commit = _ref2.commit;

    commit(types.setLogin, boolean);
  },
  setLoadingAction: function setLoadingAction(_ref3, boolean) {
    var commit = _ref3.commit;

    commit(types.setLoading, boolean);
  },
  clearLoadingAction: function clearLoadingAction(_ref4) {
    var commit = _ref4.commit;

    commit(types.clearLoading);
  },
  setSubLoadingAction: function setSubLoadingAction(_ref5, boolean) {
    var commit = _ref5.commit;

    commit(types.setSubLoading, boolean);
  },
  clearSubLoadingAction: function clearSubLoadingAction(_ref6) {
    var commit = _ref6.commit;

    commit(types.clearSubLoading);
  },
  setDialogLoadingAction: function setDialogLoadingAction(_ref7, boolean) {
    var commit = _ref7.commit;

    commit(types.setDialogLoading, boolean);
  },
  clearDialogLoadingAction: function clearDialogLoadingAction(_ref8) {
    var commit = _ref8.commit;

    commit(types.clearDialogLoading);
  },
  setUploadingAction: function setUploadingAction(_ref9, content) {
    var commit = _ref9.commit;

    commit(types.setUploading, content);
  },
  setModalAction: function setModalAction(_ref10, object) {
    var commit = _ref10.commit;

    commit(types.setModal, object);
  },
  setModal2Action: function setModal2Action(_ref11, string) {
    var commit = _ref11.commit;

    commit(types.setModal2, string);
  },
  addToastAction: function addToastAction(_ref12, object) {
    var commit = _ref12.commit;

    commit(types.addToast, object);
  },
  setBorCorAction: function setBorCorAction(_ref13, object) {
    var commit = _ref13.commit;

    commit(types.setBorCor, object);
  },
  setUnloadAlertAction: function setUnloadAlertAction(_ref14, boolean) {
    var commit = _ref14.commit;

    commit(types.setUnloadAlert, boolean);
  },
  setScrollStateAction: function setScrollStateAction(_ref15, object) {
    var commit = _ref15.commit;

    commit(types.setScrollState, object);
  },
  setAFKCountDownAction: function setAFKCountDownAction(_ref16, object) {
    var commit = _ref16.commit;

    commit(types.setAFKCountDown, object);
  }
};

/* harmony default export */ var app = ({
  state: app_state,
  getters: getters,
  mutations: mutations,
  actions: actions
});
// CONCATENATED MODULE: ./src/store/modules/global.js
var global_state = {};

var global_getters = {};

// const types = {
// }

var global_mutations = {};

var global_actions = {};

/* harmony default export */ var global = ({
  state: global_state,
  getters: global_getters,
  mutations: global_mutations,
  actions: global_actions
});
// CONCATENATED MODULE: ./src/store/modules/user.js



var user__mutations;

var user_state = {
  data: null,
  info: null
};

var user_getters = {
  user: function user(state) {
    return state.data ? extends_default()({}, state.data) : state.data;
  },
  userInfo: function userInfo(state) {
    return state.info ? extends_default()({}, state.info) : state.info;
  }
};

var user_types = {
  setUser: 'user/setUser',
  setUserInfo: 'user/setUserInfo'
};

var user_mutations = (user__mutations = {}, defineProperty_default()(user__mutations, user_types.setUser, function (state, object) {
  state.data = object;
}), defineProperty_default()(user__mutations, user_types.setUserInfo, function (state, object) {
  state.info = object;
}), user__mutations);

var user_actions = {
  setUserAction: function setUserAction(_ref, object) {
    var commit = _ref.commit;

    commit(user_types.setUser, object);
  },
  setUserInfoAction: function setUserInfoAction(_ref2, object) {
    var commit = _ref2.commit;

    commit(user_types.setUserInfo, object);
  }
};

/* harmony default export */ var modules_user = ({
  state: user_state,
  getters: user_getters,
  mutations: user_mutations,
  actions: user_actions
});
// CONCATENATED MODULE: ./src/store/index.js







vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  modules: {
    app: app,
    global: global,
    user: modules_user
  }
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








vee_validate_esm["a" /* Validator */].extend('youtubeLink', {
  getMessage: function getMessage() {
    return '';
  },
  validate: function validate(value) {
    return (/(?:src="|^)https:\/\/www\.youtube\.com\/embed\/([a-zA-Z0-9]+)(?="|$)/.test(value)
    );
  }
});

__webpack_require__("DBs5");
__webpack_require__("598Q");

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_meta_default.a);

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  store: store,
  i18n: i18n["a" /* default */],
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "OGMH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/resourceMap/data.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var data = ({
  props: {
    data: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    selectable: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  computed: {
    // static
    infoOptions: function infoOptions() {
      return [{
        title: this.$t('COMPONENT.resourceMap.data.infoOption.title.___doctor'),
        value: function value(data) {
          return data.name;
        }
      }, {
        title: this.$t('COMPONENT.resourceMap.data.infoOption.title.___address'),
        value: function value(data) {
          return [data.country, data.city].filter(function (x) {
            return x;
          }).join(' ');
        }
      }, {
        title: this.$t('COMPONENT.resourceMap.data.infoOption.title.___hospital'),
        value: function value(data) {
          return data.hospital;
        }
      }, {
        title: this.$t('COMPONENT.resourceMap.data.infoOption.title.___department'),
        value: function value(data) {
          return data.department;
        }
      }];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecc144da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resourceMap/data.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resource-map-data-page col-block width-full",class:{ selectable: _vm.selectable }},[_c('div',{staticClass:"resource-map-data-main-container row-block flex-start"},[_c('div',{staticClass:"resource-map-data-avatar-container center-block",on:{"click":function (e) { return _vm.selectable ? _vm.$emit('select', _vm.data) : ''; }}},[_c('img',{attrs:{"src":_vm.active ? __webpack_require__("ZEeh") : __webpack_require__("XRew"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"resource-map-data-info-container col-block width-full",style:({ flex: 1 })},_vm._l((_vm.infoOptions),function(infoOption,ioindex){return _c('div',{key:ioindex,staticClass:"resource-map-data-info-block row-block flex-start"},[_c('div',{staticClass:"resource-map-data-info-title"},[_vm._v(_vm._s(infoOption.title))]),_vm._v(" "),_c('div',{staticClass:"resource-map-data-info-content break-line",style:({ flex: 1 })},[_vm._v(_vm._s(infoOption.value(_vm.data) || '- -'))])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var resourceMap_data = (esExports);
// CONCATENATED MODULE: ./src/components/resourceMap/data.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  data,
  resourceMap_data,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_resourceMap_data = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OHmD":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3NiIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDc2IDI0Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzIwMTgiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDIwMTgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xODQ2MSAtNjI1NykiPgogICAgPGxpbmUgaWQ9Iue3ml8xOTUiIGRhdGEtbmFtZT0i57eaIDE5NSIgeDI9IjEyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODQ3Ni41IDYyNjkuNSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZhM2QzZCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8bGluZSBpZD0i57eaXzE5NiIgZGF0YS1uYW1lPSLnt5ogMTk2IiB4Mj0iMTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NTEwLjUgNjI2OS41KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjYWFhIiBzdHJva2Utd2lkdGg9IjIiLz4KICAgIDxnIGlkPSLmpZXlhoblvaJfMTA3IiBkYXRhLW5hbWU9IualleWGhuW9oiAxMDciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NTIxIDYyNjEpIiBmaWxsPSIjZmZmIiBzdHJva2U9IiNhYWEiIHN0cm9rZS13aWR0aD0iMSI+CiAgICAgIDxjaXJjbGUgY3g9IjgiIGN5PSI4IiByPSI4IiBzdHJva2U9Im5vbmUiLz4KICAgICAgPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjcuNSIgZmlsbD0ibm9uZSIvPgogICAgPC9nPgogICAgPGcgaWQ9IualleWGhuW9ol8xMDgiIGRhdGEtbmFtZT0i5qWV5YaG5b2iIDEwOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTg0ODcgNjI1NykiIGZpbGw9IiNmZmYiIHN0cm9rZT0iI2FhYSIgc3Ryb2tlLXdpZHRoPSIxIj4KICAgICAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIHN0cm9rZT0ibm9uZSIvPgogICAgICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMS41IiBmaWxsPSJub25lIi8+CiAgICA8L2c+CiAgICA8Y2lyY2xlIGlkPSLmpZXlhoblvaJfMTA5IiBkYXRhLW5hbWU9IualleWGhuW9oiAxMDkiIGN4PSI4IiBjeT0iOCIgcj0iOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTg0NjEgNjI2MSkiIGZpbGw9IiNmYTNkM2QiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "PNRC":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNS4wMDMiIHZpZXdCb3g9IjAgMCAxNSAxNS4wMDMiPgogIDxwYXRoIGlkPSJoZWFkLXNpZGUtbWVkaWNhbC1saWdodCIgZD0iTS45MzcsNi41NjJBNS42MjYsNS42MjYsMCwwLDEsNi41NjIuOTM3aC40NjlhNS4wNDYsNS4wNDYsMCwwLDEsNC41MDYsMi44MzljLjA5NC4yLjE5LjQxNi4yOS42MzZoMGMuMTgyLjQwNy4zNzIuODM1LjU4LDEuMjNBNS45NzIsNS45NzIsMCwwLDAsMTMuNyw3LjM4M2wuMDk0LjA4MmEuODI2LjgyNiwwLDAsMS0uNTQ4LDEuNDQ0aC0uNTg2YS40Ny40NywwLDAsMC0uNDY5LjQ2OXYxLjg3NWEuOTM2LjkzNiwwLDAsMS0uOTM4LjkzN0g4LjkwNmEuNDcuNDcsMCwwLDAtLjQ2OS40Njl2MS44NzVhLjQ2OS40NjksMCwwLDAsLjkzOCwwVjEzLjEyNUgxMS4yNWExLjg3NywxLjg3NywwLDAsMCwxLjg3NS0xLjg3NVY5Ljg0NGguMTExYTEuNzY0LDEuNzY0LDAsMCwwLDEuMTcyLTMuMDgybC0uMDk0LS4wODJhNS4wOCw1LjA4LDAsMCwxLTEuMDgxLTEuNDc0Yy0uMi0uMzcyLS4zNi0uNzQ3LS41MzMtMS4xMzRoMGMtLjEtLjIyOS0uMjA1LS40Ni0uMzE2LS43QTUuOTg0LDUuOTg0LDAsMCwwLDcuMDMxLDBINi41NjJBNi41NjQsNi41NjQsMCwwLDAsMS40MzgsMTAuNjY0YTEuNzcyLDEuNzcyLDAsMCwxLC40MzcsMS4xdjIuNzcxYS40NjkuNDY5LDAsMSwwLC45MzcsMFYxMS43NmEyLjcyLDIuNzIsMCwwLDAtLjY0Mi0xLjY4MkE1LjYsNS42LDAsMCwxLC45MzcsNi41NjJabTUuNjI1LTMuNzVhLjkzNi45MzYsMCwwLDAtLjkzNy45Mzh2LjkzOEg0LjY4OGEuOTM2LjkzNiwwLDAsMC0uOTM4LjkzN3YuOTM4YS45MzYuOTM2LDAsMCwwLC45MzguOTM4aC45Mzd2LjkzOGEuOTM2LjkzNiwwLDAsMCwuOTM4LjkzOEg3LjVhLjkzNi45MzYsMCwwLDAsLjkzOC0uOTM3VjcuNWguOTM4YS45MzYuOTM2LDAsMCwwLC45MzctLjkzN1Y1LjYyNWEuOTM2LjkzNiwwLDAsMC0uOTM3LS45MzdIOC40MzhWMy43NUEuOTM2LjkzNiwwLDAsMCw3LjUsMi44MTJabTAsMi4zNDRWMy43NUg3LjVWNS4xNTZhLjQ3LjQ3LDAsMCwwLC40NjkuNDY5SDkuMzc1di45MzhINy45NjlhLjQ3LjQ3LDAsMCwwLS40NjkuNDY5VjguNDM4SDYuNTYyVjcuMDMxYS40Ny40NywwLDAsMC0uNDY5LS40NjlINC42ODhWNS42MjVINi4wOTRhLjQ3LjQ3LDAsMCwwLC40NjktLjQ2OVoiIGZpbGw9IiMwMDM2NzkiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "SE3R":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "T452":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_ROOT2; });
var API_ROOT = {
  'development': 'https://api-edge-dev.inherinext.compassbioinfo.com/',
  'production': 'https://server-edge.inherinext.com/'
}["production"];

var API_ROOT2 = {
  'development': 'https://server.compassbioinfo.com/',
  'production': 'https://server.compassbioinfo.com/'
}["production"];

/***/ }),

/***/ "WIZk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XRew":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MiIgaGVpZ2h0PSI4MiIgdmlld0JveD0iMCAwIDgyIDgyIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzgwOTgiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDgwOTgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMDIgLTIyMikiPgogICAgPGNpcmNsZSBpZD0i5qWV5YaG5b2iXzEiIGRhdGEtbmFtZT0i5qWV5YaG5b2iIDEiIGN4PSI0MSIgY3k9IjQxIiByPSI0MSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAyIDIyMikiIGZpbGw9IiNlNGY0ZmQiLz4KICAgIDxwYXRoIGlkPSJ1c2VyLWRvY3Rvci1yZWd1bGFyIiBkPSJNMjEuODY2LDQuNjg1YTcuODA5LDcuODA5LDAsMSwxLTcuODA5LDcuODA5LDcuODA5LDcuODA5LDAsMCwxLDcuODA5LTcuODA5Wk05LjM3MSwxMi40OTVBMTIuNDk1LDEyLjQ5NSwwLDEsMCwyMS44NjYsMCwxMi40OTUsMTIuNDk1LDAsMCwwLDkuMzcxLDEyLjQ5NVptNi4yNDcsMjEuOTYzYTExLjc3MiwxMS43NzIsMCwwLDEsMS41NjItLjFoOS4zNzFhMTEuNzcyLDExLjc3MiwwLDAsMSwxLjU2Mi4xdjQuNzgzYTYuMjU0LDYuMjU0LDAsMCwwLTQuNjg1LDYuMDUydjMuMTI0YTEuNTY2LDEuNTY2LDAsMCwwLDEuNTYyLDEuNTYyaDIuMzQzYTEuNTYyLDEuNTYyLDAsMSwwLDAtMy4xMjRoLS43ODFWNDUuMjkzYTMuMTI0LDMuMTI0LDAsMSwxLDYuMjQ3LDB2MS41NjJoLS43ODFhMS41NjIsMS41NjIsMCwxLDAsMCwzLjEyNEgzNC4zNmExLjU2NiwxLjU2NiwwLDAsMCwxLjU2Mi0xLjU2MlY0NS4yOTNhNi4yNTQsNi4yNTQsMCwwLDAtNC42ODUtNi4wNTJWMzUuMjY4YTEyLjUsMTIuNSwwLDAsMSw3LjgwOSwxMS41ODd2Ljc4MWEyLjM0MywyLjM0MywwLDAsMCw0LjY4Niwwdi0uNzgxYTE3LjE4LDE3LjE4LDAsMCwwLTE3LjE4LTE3LjE4SDE3LjE4QTE3LjE4LDE3LjE4LDAsMCwwLDAsNDYuODU1di43ODFhMi4zNDMsMi4zNDMsMCwxLDAsNC42ODUsMHYtLjc4MWExMi41LDEyLjUsMCwwLDEsNy44MDktMTEuNTg3djRhNS40NjYsNS40NjYsMCwxLDAsMy4xMjQsMFptLTEuNTYyLDcuNzEyYTIuMzQzLDIuMzQzLDAsMSwxLTIuMzQzLDIuMzQzQTIuMzQzLDIuMzQzLDAsMCwxLDE0LjA1Niw0Mi4xNjlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMjEuMTM1IDIzOC4wMTEpIiBmaWxsPSIjMDAzNjc5Ii8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "ZEeh":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MiIgaGVpZ2h0PSI4MiIgdmlld0JveD0iMCAwIDgyIDgyIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzgwOTgiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDgwOTgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMDIgLTIyMikiPgogICAgPGNpcmNsZSBpZD0i5qWV5YaG5b2iXzEiIGRhdGEtbmFtZT0i5qWV5YaG5b2iIDEiIGN4PSI0MSIgY3k9IjQxIiByPSI0MSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAyIDIyMikiIGZpbGw9IiMwMDM2NzkiLz4KICAgIDxwYXRoIGlkPSJ1c2VyLWRvY3Rvci1yZWd1bGFyIiBkPSJNMjEuODY2LDQuNjg1YTcuODA5LDcuODA5LDAsMSwxLTcuODA5LDcuODA5LDcuODA5LDcuODA5LDAsMCwxLDcuODA5LTcuODA5Wk05LjM3MSwxMi40OTVBMTIuNDk1LDEyLjQ5NSwwLDEsMCwyMS44NjYsMCwxMi40OTUsMTIuNDk1LDAsMCwwLDkuMzcxLDEyLjQ5NVptNi4yNDcsMjEuOTYzYTExLjc3MiwxMS43NzIsMCwwLDEsMS41NjItLjFoOS4zNzFhMTEuNzcyLDExLjc3MiwwLDAsMSwxLjU2Mi4xdjQuNzgzYTYuMjU0LDYuMjU0LDAsMCwwLTQuNjg1LDYuMDUydjMuMTI0YTEuNTY2LDEuNTY2LDAsMCwwLDEuNTYyLDEuNTYyaDIuMzQzYTEuNTYyLDEuNTYyLDAsMSwwLDAtMy4xMjRoLS43ODFWNDUuMjkzYTMuMTI0LDMuMTI0LDAsMSwxLDYuMjQ3LDB2MS41NjJoLS43ODFhMS41NjIsMS41NjIsMCwxLDAsMCwzLjEyNEgzNC4zNmExLjU2NiwxLjU2NiwwLDAsMCwxLjU2Mi0xLjU2MlY0NS4yOTNhNi4yNTQsNi4yNTQsMCwwLDAtNC42ODUtNi4wNTJWMzUuMjY4YTEyLjUsMTIuNSwwLDAsMSw3LjgwOSwxMS41ODd2Ljc4MWEyLjM0MywyLjM0MywwLDAsMCw0LjY4Niwwdi0uNzgxYTE3LjE4LDE3LjE4LDAsMCwwLTE3LjE4LTE3LjE4SDE3LjE4QTE3LjE4LDE3LjE4LDAsMCwwLDAsNDYuODU1di43ODFhMi4zNDMsMi4zNDMsMCwxLDAsNC42ODUsMHYtLjc4MWExMi41LDEyLjUsMCwwLDEsNy44MDktMTEuNTg3djRhNS40NjYsNS40NjYsMCwxLDAsMy4xMjQsMFptLTEuNTYyLDcuNzEyYTIuMzQzLDIuMzQzLDAsMSwxLTIuMzQzLDIuMzQzQTIuMzQzLDIuMzQzLDAsMCwxLDE0LjA1Niw0Mi4xNjlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMjEuMTM1IDIzOC4wMTEpIiBmaWxsPSIjZmZmIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "cEaC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "cmUn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "dsSz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e4hu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/phenotypeDisease/pathDetail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pathDetail = ({
  props: {
    paths: {
      type: Array,
      required: true
    }
  },
  computed: {
    textData: function textData() {
      return this.paths ? {
        text: {
          '0': this.$t('COMPONENT.phenotypeDisease.pathDetail.text.___text01'),
          '1': this.$t('COMPONENT.phenotypeDisease.pathDetail.text.___text02')
        }[this.paths.length + ''] || this.$t('COMPONENT.phenotypeDisease.pathDetail.text.___text03', { length: this.paths.length - 1 })
      } : null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81ed54a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/phenotypeDisease/pathDetail.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phenotype-disease-path-detail-page col-block width-full"},[_c('div',{staticClass:"text",class:{ nodes: _vm.paths.length },domProps:{"innerHTML":_vm._s(_vm.textData.text)}}),_vm._v(" "),(_vm.paths.length)?[_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"node-container col-block"},[_c('div',{staticClass:"dash-line"}),_vm._v(" "),_vm._l((_vm.paths),function(path,index){return _c('div',{key:index,staticClass:"node-block row-block stretch"},[_vm._m(0,true),_vm._v(" "),_c('div',[_c('div',{style:({ width: '5px' })})]),_vm._v(" "),_c('div',{staticClass:"node-title"},[_vm._v(_vm._s(path.name))]),_vm._v(" "),_c('div',[_c('div',{style:({ width: '5px' })})]),_vm._v(" "),_c('div',{staticClass:"link-container"},[_c('a',{staticClass:"link",attrs:{"href":'https://hpo.jax.org/app/browse/term/' + path.id,"target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("hyNC"),"alt":""}})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])})],2)]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"point-container"},[_c('div',{staticClass:"point"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var phenotypeDisease_pathDetail = (esExports);
// CONCATENATED MODULE: ./src/components/phenotypeDisease/pathDetail.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  pathDetail,
  phenotypeDisease_pathDetail,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_phenotypeDisease_pathDetail = (Component.exports);

// EXTERNAL MODULE: ./src/components/tool/borCor.vue + 2 modules
var borCor = __webpack_require__("HALv");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/phenotypeDisease/pathIcon.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pathIcon = ({
  components: {
    pathDetail: components_phenotypeDisease_pathDetail,
    borCor: borCor["a" /* default */]
  },
  props: {
    paths: {
      type: Array,
      default: function _default() {
        return null;
      }
    },
    borCorType: {
      type: String,
      default: function _default() {
        return 'bottom';
      }
    }
  },
  computed: {
    iconData: function iconData() {
      return this.paths ? {
        src: {
          '0': __webpack_require__("kTy6"),
          '1': __webpack_require__("1n9X")
        }[this.paths.length + ''] || __webpack_require__("OHmD")
      } : null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11da738e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/phenotypeDisease/pathIcon.vue
var pathIcon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phenotype-disease-path-icon-page col-block width-full",style:({ width: '76px' })},[(_vm.paths)?_c('div',{staticClass:"phenotype-disease-path-icon-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"phenotype-disease-path-icon-block"},[_c('img',{attrs:{"src":_vm.iconData.src,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"phenotype-disease-path-icon-count-container"},[_c('borCor',{attrs:{"type":_vm.borCorType,"deviation":'15px 115px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
            padding: '6px 8px'
          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"phenotype-disease-path-icon-count center-block container-block"},[_vm._v(_vm._s(_vm.paths.length - 1 > 0 ? _vm.paths.length - 1 : ''))])]),_vm._v(" "),_c('div',{staticClass:"phenotype-disease-path-icon-count-content col-block",attrs:{"slot":"content"},slot:"content"},[_c('pathDetail',{attrs:{"paths":_vm.paths}})],1)])],1)])]):_vm._e()])}
var pathIcon_staticRenderFns = []
var pathIcon_esExports = { render: pathIcon_render, staticRenderFns: pathIcon_staticRenderFns }
/* harmony default export */ var phenotypeDisease_pathIcon = (pathIcon_esExports);
// CONCATENATED MODULE: ./src/components/phenotypeDisease/pathIcon.vue
var pathIcon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pathIcon___vue_template_functional__ = false
/* styles */
var pathIcon___vue_styles__ = null
/* scopeId */
var pathIcon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pathIcon___vue_module_identifier__ = null
var pathIcon_Component = pathIcon_normalizeComponent(
  pathIcon,
  phenotypeDisease_pathIcon,
  pathIcon___vue_template_functional__,
  pathIcon___vue_styles__,
  pathIcon___vue_scopeId__,
  pathIcon___vue_module_identifier__
)

/* harmony default export */ var components_phenotypeDisease_pathIcon = (pathIcon_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/phenotypeDisease/network.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var network = ({
  components: {
    pathIcon: components_phenotypeDisease_pathIcon
  },
  props: {
    hpoNetworks: {
      type: Object,
      required: true
    },
    borCorType: {
      type: String,
      default: function _default() {
        return 'bottom';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66705378","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/phenotypeDisease/network.vue
var network_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phenotype-disease-network-page col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"phenotype-disease-network-list-container col-block width-full"},_vm._l((_vm.hpoNetworks),function(hpo,hpoID,hindex){return _c('div',{key:hindex,staticClass:"phenotype-disease-network-container row-block flex-start"},[_c('div',{staticClass:"phenotype-disease-network-path-container row-block",style:({ width: '220px' })},[(hpo.path)?[_c('div',{staticClass:"phenotype-disease-network-path-title ellipsis",style:({ flex: 1 }),attrs:{"title":hpo.path[hpo.path.length - 1].name}},[_vm._v(_vm._s(hpo.path[hpo.path.length - 1].name))]),_vm._v(" "),_c('a',{staticClass:"phenotype-disease-network-path-icon icon-block",style:({ '--size': '12px' }),attrs:{"href":hpo.path[hpo.path.length - 1].url,"target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("hyNC"),"alt":""}})])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"phenotype-disease-network-icon-container row-block"},[_c('pathIcon',{attrs:{"paths":hpo.path || (hpo.result === 'no_hit' ? null : []),"borCorType":_vm.borCorType}})],1),_vm._v(" "),_c('div',{staticClass:"phenotype-disease-network-hpo-container row-block",style:({ flex: 1, width: 0 })},[_c('div',{staticClass:"phenotype-disease-network-path-title shrink ellipsis",attrs:{"title":hpo.name}},[_vm._v(_vm._s(hpo.name))]),_vm._v(" "),_c('a',{staticClass:"phenotype-disease-network-path-icon icon-block",style:({ '--size': '12px' }),attrs:{"href":hpo.url,"target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("hyNC"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}),0)])}
var network_staticRenderFns = []
var network_esExports = { render: network_render, staticRenderFns: network_staticRenderFns }
/* harmony default export */ var phenotypeDisease_network = (network_esExports);
// CONCATENATED MODULE: ./src/components/phenotypeDisease/network.vue
var network_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var network___vue_template_functional__ = false
/* styles */
var network___vue_styles__ = null
/* scopeId */
var network___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var network___vue_module_identifier__ = null
var network_Component = network_normalizeComponent(
  network,
  phenotypeDisease_network,
  network___vue_template_functional__,
  network___vue_styles__,
  network___vue_scopeId__,
  network___vue_module_identifier__
)

/* harmony default export */ var components_phenotypeDisease_network = __webpack_exports__["a"] = (network_Component.exports);


/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSearchPhenotype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSearchGeneEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getUserToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDisimJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return postDisimJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return putDisimJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return postHistoryDisimJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getGenePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return postHistoryPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getRescoureMapDatas; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("T452");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__ = __webpack_require__("tZBu");







// import { toFormdata } from '../constants/global/util'

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);

var apiLocaleMap = { 'tc': 'zh', 'en': 'en', 'ja': 'jp'

  // auto complete
};var getSearchPhenotype = function getSearchPhenotype(query, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/phenotypes', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { q: query, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getSearchGeneEntry = function getSearchGeneEntry(query, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/demo_gene_panel_entries', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { q: query, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// user
var getUserToken = function getUserToken(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/current_user', { params: config });
};
// phenotype disease
var getDisimJob = function getDisimJob(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'demo/pgd_query_jobs/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postDisimJob = function postDisimJob(identity, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'demo/pgd_query_jobs', { identity: identity }, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putDisimJob = function putDisimJob(id, phenotypes, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'demo/pgd_query_jobs/' + id, { phenotypes: phenotypes }, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postHistoryDisimJob = function postHistoryDisimJob(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'demo/pgd_query_jobs/' + id + '/history', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// gene page
var getGenePanel = function getGenePanel(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'demo/demo_gene_panels/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postHistoryPanel = function postHistoryPanel(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'demo/demo_gene_panels/' + id + '/history', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// resource map
var getRescoureMapDatas = function getRescoureMapDatas() {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["b" /* API_ROOT2 */] + 'map/map_' + apiLocaleMap[__WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale], { params: { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale } });
};

/***/ }),

/***/ "hyNC":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIj4KICA8cGF0aCBpZD0iZXh0ZXJuYWwtbGluay1yZWd1bGFyIiBkPSJNMTEuNjYzLDAsNy44MzcsMEEuMzM3LjMzNywwLDAsMCw3LjUuMzQxdi43ODFhLjMzOC4zMzgsMCwwLDAsLjM0NC4zMzhMOS41NywxLjRsLjA0OC4wNDhMMy4wODIsNy45OGEuMjgxLjI4MSwwLDAsMCwwLC40bC41MzkuNTM5YS4yODEuMjgxLDAsMCwwLC40LDBsNi41MzYtNi41MzYuMDQ4LjA0OEwxMC41NCw0LjE1NmEuMzM4LjMzOCwwLDAsMCwuMzM3LjM0NGguNzgxQS4zMzcuMzM3LDAsMCwwLDEyLDQuMTYzTDEyLC4zMzdBLjMzNy4zMzcsMCwwLDAsMTEuNjYzLDBaTTEwLjEyNSw2Ljc1SDkuNzVhLjM3NS4zNzUsMCwwLDAtLjM3NS4zNzV2My42MDlhLjE0MS4xNDEsMCwwLDEtLjE0MS4xNDFIMS4yNjZhLjE0MS4xNDEsMCwwLDEtLjE0MS0uMTQxVjIuNzY2YS4xNDEuMTQxLDAsMCwxLC4xNDEtLjE0MUg0Ljg3NUEuMzc1LjM3NSwwLDAsMCw1LjI1LDIuMjVWMS44NzVBLjM3NS4zNzUsMCwwLDAsNC44NzUsMS41SDEuMTI1QTEuMTI1LDEuMTI1LDAsMCwwLDAsMi42MjV2OC4yNUExLjEyNSwxLjEyNSwwLDAsMCwxLjEyNSwxMmg4LjI1QTEuMTI1LDEuMTI1LDAsMCwwLDEwLjUsMTAuODc1VjcuMTI1QS4zNzUuMzc1LDAsMCwwLDEwLjEyNSw2Ljc1WiIgZmlsbD0iIzAwNmVkNiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "jNsU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),

/***/ "kTy6":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBpZD0i5qWV5YaG5b2iXzExMCIgZGF0YS1uYW1lPSLmpZXlhoblvaIgMTEwIiBmaWxsPSIjZmEzZDNkIiBzdHJva2U9IiNmYTNkM2QiIHN0cm9rZS13aWR0aD0iMSI+CiAgICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iOCIgc3Ryb2tlPSJub25lIi8+CiAgICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iNy41IiBmaWxsPSJub25lIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "nCot":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "nzHv":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzY1MTAiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDY1MTAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwMzQ0IDU2MDIpIj4KICAgIDxyZWN0IGlkPSLplbfmlrnlvaJfMTc3MyIgZGF0YS1uYW1lPSLplbfmlrnlvaIgMTc3MyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjAzNDQgLTU2MDIpIiBmaWxsPSIjZmZmIiBvcGFjaXR5PSIwIi8+CiAgICA8cGF0aCBpZD0idGltZXMtbGlnaHQiIGQ9Ik03LjI3MywxMDJsMy44NDYtMy44NDYuNzkzLS43OTNhLjMuMywwLDAsMCwwLS40MjRsLS44NDktLjg0OWEuMy4zLDAsMCwwLS40MjQsMEw2LDEwMC43MjdsLTQuNjM5LTQuNjRhLjMuMywwLDAsMC0uNDI0LDBsLS44NDkuODQ5YS4zLjMsMCwwLDAsMCwuNDI0TDQuNzI3LDEwMmwtNC42NCw0LjYzOWEuMy4zLDAsMCwwLDAsLjQyNGwuODQ5Ljg0OWEuMy4zLDAsMCwwLC40MjQsMEw2LDEwMy4yNzNsMy44NDYsMy44NDYuNzkzLjc5M2EuMy4zLDAsMCwwLC40MjQsMGwuODQ5LS44NDlhLjMuMywwLDAsMCwwLS40MjRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjAzNDAgLTU2OTQpIiBmaWxsPSIjOTk5IiBvcGFjaXR5PSIwLjYiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "of+2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),

/***/ "tZBu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// CONCATENATED MODULE: ./src/constants/lang/en/lang.js
/* harmony default export */ var lang = ({
  // layout
  LAYOUT: {
    sidebar: {
      ___logoTitle: 'COMPASS BIOINFORMATICS',
      ___tryButton01: 'Try',
      ___tryButton02: 'InheriNext',
      menuOption: {
        title: {
          ___phenotype: 'Phenotype',
          ___genePanel: 'Panel',
          ___disease: 'Disease',
          ___introduction: 'Introduction'
        }
      }
    },
    header: {
      ___webTitle: 'InheriNext Expert',
      ___logoTitle: 'COMPASS BIOINFORMATICS'
    },
    footer: {
      ___companyTitle: 'COMPASS BIOINFORMATICS INC.'
    },
    uploading: {
      ___default: 'Uploading'
    },
    dialog: {
      selectIdentity: {
        ___title: 'What Is Your Identity?',
        option: {
          ___patient: 'Patient or<br>Patient’s Family',
          ___doctor: 'Physicians'
        }
      },
      phenotypeMore: {
        ___title: 'Single gene result'
      },
      toast: {
        title: {
          ___success: 'Success',
          ___error: 'Error'
        },
        content: {
          ___jobFailed: 'Job failed.'
        }
      }
    }
  },
  // page
  PAGE: {
    main: {
      ___mainTitle: 'Inherinext Search Tools',
      introduction: {
        ___alert: 'The results from the above search tools are only for reference, not for diagnosis.',
        title: {
          ___overview: 'Overview',
          ___phenotype: 'Phenotype',
          ___genePanel: 'Gene Panel'
        },
        content: {
          ___overview01: 'This website, developed by Compass Bioinformatics Inc., provides users with search tools related to phenotypes and genes of inherited diseases. If you want to experience more comprehensive functionalities related to inherited disease detection, please try InheriNext.',
          ___overview02: 'Compass Bioinformatics Inc. is a software development company dedicated to translating genetic data into clinically useful information. InheriNext is our flagship product, providing healthcare professionals with comprehensive genetic information for better medical judgments in genetic and rare diseases.',
          ___phenotype01: 'Users can input phenotypes using Human Phenotype Ontology (HPO) numbers or terms. Our system then calculates the correlation between these characteristics and genes, displaying the most relevant diseases associated with the identified genes. Additionally, we describe the consistency between the entered phenotype and the suggested diseases.',
          ___genePanel01: 'Users can search for relevant gene panels by entering disease or phenotype terms. The system then presents a list of associated genes collected from the literature for their reference. Additionally, users have the option to download the gene list to assist in further analysis or review.'
        }
      }
    },
    genePanel: {
      ___title01: 'Enter Your Interested Disease,',
      ___title02: 'Retrieve a List of associated Genes',
      geneTag: {
        ___placeholder: 'Typing Disease or Gene panel'
      },
      introduction: {
        ___content01: 'e. g. Marfan syndrome, Leber hereditary optic neuropathy, Fabry disease, Epilepsy, Noonan and RASopathies…'
      }
    },
    phenotypeDisease: {
      ___title01: 'Provide me with Phenotypes,',
      ___title02: 'Find the most likely related Gene and Disease',
      ___selectedTitle: 'Selected',
      phenotypeTag: {
        ___placeholder: 'Typing Phenotype'
      },
      introduction: {
        ___content01: 'e. g. Global developmental delay, Short stature, Hypotonia, Nystagmus, Hearing impairment, Intellectual disability, Microcephaly…'
      },
      result: {
        ___phenotypeTitle: 'Imported Phenotypes',
        ___tableTitle: 'Results',
        alert: {
          ___content01: 'The results are only for reference,',
          ___content02: 'not for diagnosis.'
        }
      },
      table: {
        ___more: 'More',
        title: {
          ___gene: 'Gene',
          ___disease: 'Disease',
          ___phenotype: 'Phenotype Network',
          ___phenotypeMobile: 'Phe'
        }
      },
      uploading: {
        ___pleaseWait: 'Please do not leave the page and wait for a moment'
      }
    },
    resourceMap: {
      ___title: 'Resource map',
      filterOption: {
        title: {
          ___country: 'Type Country',
          ___city: 'Type City',
          ___hospital: 'Type Hospital',
          ___department: 'Type Department'
        }
      }
    }
  },
  // component
  COMPONENT: {
    resourceMap: {
      data: {
        infoOption: {
          title: {
            ___doctor: 'Doctor',
            ___address: 'Address',
            ___hospital: 'Hospital',
            ___department: 'Department'
          }
        }
      }
    },
    phenotypeDisease: {
      pathDetail: {
        text: {
          ___text01: 'It directly maps to the condition-<br>associated HPO.',
          ___text02: 'It indirectly maps to the condition-associated HPO.',
          ___text03: 'A path of similarity shows a connection from the provided HPO term to the condition-associated HPO term through <b>{length}</b> neighborhood(s).'
        }
      }
    },
    tool: {
      geneTag: {
        ___empty: 'No result has been found.',
        info: {
          ___gene: 'genes',
          ___genePanel: 'gene panels',
          ___phenotype: 'phenotypes',
          ___condition: 'conditions',
          ___add: 'add'
        },
        title: {
          ___gene: 'Genes',
          ___genePanel: 'Panels',
          ___phenotype: 'Phenotypes',
          ___condition: 'Conditions'
        }
      },
      phenotypeTag: {
        info: {
          ___phenotype: 'phenotypes',
          ___disease: 'diseases',
          ___add: 'add'
        },
        title: {
          ___phenotype: 'Phenotypes',
          ___disease: 'Diseases'
        },
        ___empty: 'No result has been found.'
      }
    }
  },
  // common
  COMMON: {
    button: {
      ___add: 'Add',
      ___download: 'Download',
      ___back: 'Back',
      ___find: 'Find',
      ___search: 'Search',
      ___cancel: 'Cancel',
      ___resourceMap: 'Resource map'
    },
    toast: {
      ___noPermission: 'No Permission',
      ___pleaseLogin: 'Please Login',
      ___pageNotFound: 'Page Not Found',
      ___phenotypesAnalyzeLimit: 'More than {amount} phenotypes cannot be analyzed.'
    }
  }
});
// CONCATENATED MODULE: ./src/constants/lang/ja/lang.js
/* harmony default export */ var ja_lang = ({
  // layout
  LAYOUT: {
    sidebar: {
      ___logoTitle: 'COMPASS株式会社',
      ___tryButton01: '試す',
      ___tryButton02: 'InheriNextを',
      menuOption: {
        title: {
          ___phenotype: '表現型',
          ___genePanel: 'パネル',
          ___disease: '疾患',
          ___introduction: 'イントロダクション'
        }
      }
    },
    header: {
      ___webTitle: 'InheriNext Expert',
      ___logoTitle: 'COMPASS株式会社'
    },
    footer: {
      ___companyTitle: 'COMPASS株式会社'
    },
    uploading: {
      ___default: 'アップロード中'
    },
    dialog: {
      selectIdentity: {
        ___title: 'あなたは医療関係者ですか？',
        option: {
          ___patient: '患者または<br>患者の家族',
          ___doctor: '医師'
        }
      },
      phenotypeMore: {
        ___title: '単一遺伝子の結果'
      },
      toast: {
        title: {
          ___success: '成功',
          ___error: 'エラー'
        },
        content: {
          ___jobFailed: '失敗しました。'
        }
      }
    }
  },
  // page
  PAGE: {
    main: {
      ___mainTitle: 'Inherinext Search Tools',
      introduction: {
        ___alert: 'The results from the above search tools are only for reference, not for diagnosis.',
        title: {
          ___overview: 'Overview',
          ___phenotype: 'Phenotype',
          ___genePanel: 'Gene Panel'
        },
        content: {
          ___overview01: 'This website, developed by Compass Bioinformatics Inc., provides users with search tools related to phenotypes and genes of inherited diseases. If you want to experience more comprehensive functionalities related to inherited disease detection, please try InheriNext.',
          ___overview02: 'Compass Bioinformatics Inc. is a software development company dedicated to translating genetic data into clinically useful information. InheriNext is our flagship product, providing healthcare professionals with comprehensive genetic information for better medical judgments in genetic and rare diseases.',
          ___phenotype01: 'Users can input phenotypes using Human Phenotype Ontology (HPO) numbers or terms. Our system then calculates the correlation between these characteristics and genes, displaying the most relevant diseases associated with the identified genes. Additionally, we describe the consistency between the entered phenotype and the suggested diseases.',
          ___genePanel01: 'Users can search for relevant gene panels by entering disease or phenotype terms. The system then presents a list of associated genes collected from the literature for their reference. Additionally, users have the option to download the gene list to assist in further analysis or review.'
        }
      }
    },
    genePanel: {
      ___title01: '興味のある疾患を入力し、',
      ___title02: '関連遺伝子リストを取得する。',
      geneTag: {
        ___placeholder: '疾患または遺伝子パネルを入力してください。'
      },
      introduction: {
        ___content01: '例）Marfan syndrome、Leber hereditary optic neuropathy、Fabry disease, Epilepsy、Noonan and RASopathiesなど。'
      }
    },
    phenotypeDisease: {
      ___title01: '表現型を入力し、',
      ___title02: '最も関連性の高い遺伝子と疾患を検索する。',
      ___selectedTitle: '選択済み',
      phenotypeTag: {
        ___placeholder: '表現型を入力'
      },
      introduction: {
        ___content01: '例）Global developmental delay、Short stature、Hypotonia、Nystagmus、Hearing impairment、Intellectual disability、Microcephalyなど。'
      },
      result: {
        ___phenotypeTitle: 'インポートした表現型',
        ___tableTitle: '結果',
        alert: {
          ___content01: '結果はあくまでも参考で、',
          ___content02: '診断のためではありません。'
        }
      },
      table: {
        ___more: '詳細',
        title: {
          ___gene: '遺伝子',
          ___disease: '疾患',
          ___phenotype: '表現型ネットワーク',
          ___phenotypeMobile: '表現型'
        }
      },
      uploading: {
        ___pleaseWait: 'ページを離れずにしばらくお待ちください。'
      }
    },
    resourceMap: {
      ___title: 'リソースマップ',
      filterOption: {
        title: {
          ___country: '国を入力',
          ___city: '市を入力',
          ___hospital: '病院名を入力',
          ___department: '診療科を入力'
        }
      }
    }
  },
  // component
  COMPONENT: {
    resourceMap: {
      data: {
        infoOption: {
          title: {
            ___doctor: '医師',
            ___address: '住所',
            ___hospital: '病院名',
            ___department: '専門分野'
          }
        }
      }
    },
    phenotypeDisease: {
      pathDetail: {
        text: {
          ___text01: 'これは、条件に関連するHPOに直接マッピングされます。',
          ___text02: 'これは、条件に関連するHPOに直接マッピングされます。',
          ___text03: '類似性のパスは、提供されたHPOの用語から<b>{length}</b>つの近傍を介した条件に関するHPOの用語への連結で示す。'
        }
      }
    },
    tool: {
      geneTag: {
        ___empty: '該当する結果は見つかりませんでした。',
        info: {
          ___gene: '遺伝子',
          ___genePanel: '遺伝子パネル',
          ___phenotype: '表現型',
          ___condition: '疾患',
          ___add: '追加'
        },
        title: {
          ___gene: '遺伝子',
          ___genePanel: 'パネル',
          ___phenotype: '表現型',
          ___condition: '疾患'
        }
      },
      phenotypeTag: {
        info: {
          ___phenotype: '表現型',
          ___disease: '疾患',
          ___add: '追加'
        },
        title: {
          ___phenotype: '表現型',
          ___disease: '疾患'
        },
        ___empty: '該当する結果は見つかりませんでした。'
      }
    }
  },
  // common
  COMMON: {
    button: {
      ___add: '追加',
      ___download: 'ダウンロード',
      ___back: '戻る',
      ___find: '取得',
      ___search: '検索',
      ___cancel: 'キャンセル',
      ___resourceMap: 'リソースマップ'
    },
    toast: {
      ___noPermission: '権限がありません。',
      ___pleaseLogin: 'ログインしてください。',
      ___pageNotFound: 'ページが見つかりません。',
      ___phenotypesAnalyzeLimit: '{amount}以上の表現型を解析することはできません。'
    }
  }
});
// CONCATENATED MODULE: ./src/constants/lang/i18n.js





vue_esm["a" /* default */].use(vue_i18n_esm["a" /* default */]);

var locale = localStorage.getItem('locale') || 'en';

var i18n = new vue_i18n_esm["a" /* default */]({
  locale: locale,
  messages: { en: lang, ja: ja_lang }
});

/* harmony default export */ var lang_i18n = __webpack_exports__["a"] = (i18n);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e40875039d6e634ffd2f.js